export const nswInstallsData = [
  {
    "name": "Abbotsford",
    "value": 2,
    "lat": -33.8505529,
    "lng": 151.129759
  },
  {
    "name": "Aberdare",
    "value": 1,
    "lat": -32.8427754,
    "lng": 151.3802736
  },
  {
    "name": "Aberdeen",
    "value": 1,
    "lat": -32.1668599,
    "lng": 150.8919596
  },
  {
    "name": "Aberglasslyn",
    "value": 1,
    "lat": -32.6983338,
    "lng": 151.5344427
  },
  {
    "name": "Adamstown",
    "value": 5,
    "lat": -32.9337786,
    "lng": 151.7200237
  },
  {
    "name": "Afterlee",
    "value": 1,
    "lat": -28.5854284,
    "lng": 152.8284051
  },
  {
    "name": "Agnes Banks",
    "value": 1,
    "lat": -33.6145082,
    "lng": 150.7114482
  },
  {
    "name": "Airds",
    "value": 12,
    "lat": -34.09,
    "lng": 150.8261111
  },
  {
    "name": "Airside",
    "value": 2,
    "lat": -33.9268472,
    "lng": 151.1811538
  },
  {
    "name": "Albion Park",
    "value": 5,
    "lat": -34.5629223,
    "lng": 150.7986248
  },
  {
    "name": "Alexandria",
    "value": 16,
    "lat": -33.9091568,
    "lng": 151.1921281
  },
  {
    "name": "Alfords Point",
    "value": 1,
    "lat": -33.977670450000005,
    "lng": 151.03041565
  },
  {
    "name": "Allambie Heights",
    "value": 1,
    "lat": -33.7705067,
    "lng": 151.249675
  },
  {
    "name": "Allworth",
    "value": 1,
    "lat": -32.5399586,
    "lng": 151.9589534
  },
  {
    "name": "Alstonville",
    "value": 5,
    "lat": -28.8412757,
    "lng": 153.4405813
  },
  {
    "name": "Ambarvale",
    "value": 5,
    "lat": -34.0844252,
    "lng": 150.8017477
  },
  {
    "name": "Anna Bay",
    "value": 2,
    "lat": -32.7779061,
    "lng": 152.0890203
  },
  {
    "name": "Annandale",
    "value": 3,
    "lat": -33.881224,
    "lng": 151.1709976
  },
  {
    "name": "Annangrove",
    "value": 2,
    "lat": -33.6574838,
    "lng": 150.9460077
  },
  {
    "name": "Appin",
    "value": 10,
    "lat": -34.2029671,
    "lng": 150.7872441
  },
  {
    "name": "Arcadia Vale",
    "value": 2,
    "lat": -33.0605545,
    "lng": 151.5842888
  },
  {
    "name": "Argenton",
    "value": 2,
    "lat": -32.9352978,
    "lng": 151.632185
  },
  {
    "name": "Arncliffe",
    "value": 4,
    "lat": -33.938236,
    "lng": 151.145508
  },
  {
    "name": "Arndell Park",
    "value": 3,
    "lat": -33.79,
    "lng": 150.8761111
  },
  {
    "name": "Artarmon",
    "value": 2,
    "lat": -33.8084051,
    "lng": 151.184511
  },
  {
    "name": "Ashbury",
    "value": 1,
    "lat": -33.9001107,
    "lng": 151.1180724
  },
  {
    "name": "Ashfield",
    "value": 3,
    "lat": -33.8894781,
    "lng": 151.1274125
  },
  {
    "name": "Asquith",
    "value": 2,
    "lat": -33.6886841,
    "lng": 151.1080776
  },
  {
    "name": "Auburn",
    "value": 10,
    "lat": -33.8545702,
    "lng": 151.0255673
  },
  {
    "name": "Audley",
    "value": 1,
    "lat": -34.0749329,
    "lng": 151.0560777
  },
  {
    "name": "Austinmer",
    "value": 4,
    "lat": -34.3064627,
    "lng": 150.9292162
  },
  {
    "name": "Austral",
    "value": 52,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Austral NSW",
    "value": 1,
    "lat": -33.9282672,
    "lng": 150.8082824
  },
  {
    "name": "Avalon Beach",
    "value": 6,
    "lat": -33.6365039,
    "lng": 151.3290299
  },
  {
    "name": "Awaba",
    "value": 1,
    "lat": -33.0129364,
    "lng": 151.5416169
  },
  {
    "name": "Badgerys Creek",
    "value": 13,
    "lat": -33.8831452,
    "lng": 150.742466
  },
  {
    "name": "Balgowlah Heights",
    "value": 1,
    "lat": -33.807495,
    "lng": 151.2649923
  },
  {
    "name": "Ballina",
    "value": 9,
    "lat": -28.86574,
    "lng": 153.5659468
  },
  {
    "name": "Balmain",
    "value": 4,
    "lat": -33.8583992,
    "lng": 151.1807353
  },
  {
    "name": "Balmain East",
    "value": 2,
    "lat": -33.8571789,
    "lng": 151.192354
  },
  {
    "name": "Balmoral",
    "value": 1,
    "lat": -34.3057922,
    "lng": 150.5228239
  },
  {
    "name": "Bangalow",
    "value": 8,
    "lat": -28.6816667,
    "lng": 153.5177778
  },
  {
    "name": "Bangor",
    "value": 2,
    "lat": -34.0155034,
    "lng": 151.0334872
  },
  {
    "name": "Banksmeadow",
    "value": 14,
    "lat": -33.9542459,
    "lng": 151.2157073
  },
  {
    "name": "Bankstown",
    "value": 10,
    "lat": -33.9171897,
    "lng": 151.0335881
  },
  {
    "name": "Bankstown Aerodrome",
    "value": 8,
    "lat": -33.9235,
    "lng": 150.9901
  },
  {
    "name": "Banora Point",
    "value": 4,
    "lat": -28.2220841,
    "lng": 153.5370661
  },
  {
    "name": "Barangaroo",
    "value": 1,
    "lat": -33.8614084,
    "lng": 151.2016877
  },
  {
    "name": "Barden Ridge",
    "value": 3,
    "lat": -34.0311727,
    "lng": 151.0105268
  },
  {
    "name": "Bardwell Valley",
    "value": 2,
    "lat": -33.937452,
    "lng": 151.1304335
  },
  {
    "name": "Barrack Heights",
    "value": 1,
    "lat": -34.5652021,
    "lng": 150.8507363
  },
  {
    "name": "Bass Hill",
    "value": 2,
    "lat": -33.8986251,
    "lng": 150.9974484
  },
  {
    "name": "Batemans Bay",
    "value": 1,
    "lat": -35.7072183,
    "lng": 150.178289
  },
  {
    "name": "Bathurst",
    "value": 2,
    "lat": -33.4166378,
    "lng": 149.5804943
  },
  {
    "name": "Baulkham Hills",
    "value": 17,
    "lat": -33.7611198,
    "lng": 150.9914041
  },
  {
    "name": "Beacon Hill",
    "value": 1,
    "lat": -33.751787,
    "lng": 151.2600828
  },
  {
    "name": "Beaumont Hills",
    "value": 3,
    "lat": -33.6997222,
    "lng": 150.9405556
  },
  {
    "name": "Beecroft",
    "value": 8,
    "lat": -33.7497631,
    "lng": 151.0657475
  },
  {
    "name": "Bella Vista",
    "value": 1,
    "lat": -33.7406251,
    "lng": 150.9532825
  },
  {
    "name": "Bellevue Hill",
    "value": 8,
    "lat": -33.8797123,
    "lng": 151.2561988
  },
  {
    "name": "Belmont",
    "value": 11,
    "lat": -33.0331697,
    "lng": 151.6585586
  },
  {
    "name": "Belmont North",
    "value": 1,
    "lat": -33.0154318,
    "lng": 151.6740434
  },
  {
    "name": "Belmont South",
    "value": 3,
    "lat": -33.0331697,
    "lng": 151.6585586
  },
  {
    "name": "Belmore",
    "value": 12,
    "lat": -33.9171961,
    "lng": 151.0887104
  },
  {
    "name": "Belmore NSW",
    "value": 1,
    "lat": -33.9165797,
    "lng": 151.0947041
  },
  {
    "name": "Belrose",
    "value": 3,
    "lat": -33.730009,
    "lng": 151.2191438
  },
  {
    "name": "Bendolba",
    "value": 1,
    "lat": -32.3268672,
    "lng": 151.7270499
  },
  {
    "name": "Berala",
    "value": 1,
    "lat": -33.8719154,
    "lng": 151.0322942
  },
  {
    "name": "Beresfield",
    "value": 8,
    "lat": -32.7989679,
    "lng": 151.6579012
  },
  {
    "name": "Berkeley",
    "value": 1,
    "lat": -34.4774294,
    "lng": 150.8448548
  },
  {
    "name": "Berkeley Vale",
    "value": 4,
    "lat": -33.34,
    "lng": 151.4344444
  },
  {
    "name": "Berkshire Park",
    "value": 2,
    "lat": -33.6816667,
    "lng": 150.7844444
  },
  {
    "name": "Berowra",
    "value": 2,
    "lat": -33.6406465,
    "lng": 151.10420756817052
  },
  {
    "name": "Berowra Heights",
    "value": 4,
    "lat": -33.6134319,
    "lng": 151.1395327
  },
  {
    "name": "Berowra Waters",
    "value": 1,
    "lat": -33.5994177,
    "lng": 151.1229517
  },
  {
    "name": "Beverly Hills",
    "value": 4,
    "lat": -33.9490787,
    "lng": 151.0810471
  },
  {
    "name": "Bexhill",
    "value": 2,
    "lat": -28.7631637,
    "lng": 153.3480115
  },
  {
    "name": "Bexley",
    "value": 3,
    "lat": -33.9523543,
    "lng": 151.1181427
  },
  {
    "name": "Bexley North",
    "value": 1,
    "lat": -33.9425365,
    "lng": 151.1152081
  },
  {
    "name": "Bextull",
    "value": 1,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Bidwill",
    "value": 1,
    "lat": -33.7319476,
    "lng": 150.823408
  },
  {
    "name": "Bilambil Heights",
    "value": 1,
    "lat": -28.2103755,
    "lng": 153.4866586
  },
  {
    "name": "Bilgola Plateau",
    "value": 1,
    "lat": -33.6438092,
    "lng": 151.315858
  },
  {
    "name": "Birchgrove",
    "value": 2,
    "lat": -33.849410899999995,
    "lng": 151.18155185197034
  },
  {
    "name": "Birrong",
    "value": 14,
    "lat": -33.8933152,
    "lng": 151.0240303
  },
  {
    "name": "Blackbrook",
    "value": 2,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Blackheath",
    "value": 1,
    "lat": -33.6338889,
    "lng": 150.2847222
  },
  {
    "name": "Blacktown",
    "value": 17,
    "lat": -33.7739882,
    "lng": 150.9036186
  },
  {
    "name": "Blacktown/Seven Hills",
    "value": 1,
    "lat": -33.7760305,
    "lng": 150.9427044
  },
  {
    "name": "Blackwall",
    "value": 1,
    "lat": -33.5042284,
    "lng": 151.329384
  },
  {
    "name": "Blair Athol",
    "value": 1,
    "lat": -34.0627778,
    "lng": 150.7997222
  },
  {
    "name": "Blakebrook",
    "value": 3,
    "lat": -28.765,
    "lng": 153.2511111
  },
  {
    "name": "Blakehurst",
    "value": 2,
    "lat": -33.9805767,
    "lng": 151.11324456169552
  },
  {
    "name": "Blues Point",
    "value": 1,
    "lat": -33.850603,
    "lng": 151.203892
  },
  {
    "name": "Blueys Beach",
    "value": 1,
    "lat": -32.3491667,
    "lng": 152.5316667
  },
  {
    "name": "Bobs Farm",
    "value": 1,
    "lat": -32.765,
    "lng": 152.0177778
  },
  {
    "name": "Bondi",
    "value": 2,
    "lat": -33.8923133,
    "lng": 151.27531373710235
  },
  {
    "name": "Bondi Beach",
    "value": 7,
    "lat": -33.8923133,
    "lng": 151.27531373710235
  },
  {
    "name": "Bondi Junction",
    "value": 4,
    "lat": -33.8912429,
    "lng": 151.248455
  },
  {
    "name": "Bonnet Bay",
    "value": 1,
    "lat": -34.0101087,
    "lng": 151.053572
  },
  {
    "name": "Bonnyrigg",
    "value": 20,
    "lat": -33.8936698,
    "lng": 150.888281
  },
  {
    "name": "Bonnyrigg Heights",
    "value": 3,
    "lat": -33.8912101,
    "lng": 150.8695795
  },
  {
    "name": "Boolaroo",
    "value": 1,
    "lat": -32.9466667,
    "lng": 151.6277778
  },
  {
    "name": "Booragul",
    "value": 5,
    "lat": -32.9747222,
    "lng": 151.6105556
  },
  {
    "name": "Boorgaul",
    "value": 2,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Bossley Park",
    "value": 7,
    "lat": -33.8622222,
    "lng": 150.8844444
  },
  {
    "name": "Botany",
    "value": 12,
    "lat": -33.9815082,
    "lng": 151.17961691669925
  },
  {
    "name": "Bowral",
    "value": 9,
    "lat": -34.4816626,
    "lng": 150.4177868
  },
  {
    "name": "Box Hill",
    "value": 33,
    "lat": -33.6425,
    "lng": 150.8988889
  },
  {
    "name": "Bradbury",
    "value": 5,
    "lat": -34.0816667,
    "lng": 150.8177778
  },
  {
    "name": "Braemar",
    "value": 1,
    "lat": -34.4251065,
    "lng": 150.4789926
  },
  {
    "name": "Braemer",
    "value": 1,
    "lat": -30.8108773,
    "lng": 150.7921593
  },
  {
    "name": "Braidwood",
    "value": 1,
    "lat": -35.4388907,
    "lng": 149.7955552
  },
  {
    "name": "Braxton",
    "value": 2,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Bray Park",
    "value": 1,
    "lat": -28.3408333,
    "lng": 153.3761111
  },
  {
    "name": "Brighton-Le-Sands",
    "value": 3,
    "lat": -33.9580947,
    "lng": 151.1526052
  },
  {
    "name": "Bringelly",
    "value": 2,
    "lat": -33.9393505,
    "lng": 150.7309705
  },
  {
    "name": "Broadmeadow",
    "value": 2,
    "lat": -32.9231318,
    "lng": 151.7344455
  },
  {
    "name": "Broadwater",
    "value": 5,
    "lat": -29.0139764,
    "lng": 153.432098
  },
  {
    "name": "Broadway",
    "value": 1,
    "lat": -33.8831394,
    "lng": 151.1939011
  },
  {
    "name": "Bronte",
    "value": 3,
    "lat": -33.9042128,
    "lng": 151.2637774
  },
  {
    "name": "Brookdale",
    "value": 1,
    "lat": -35.1077778,
    "lng": 147.0119444
  },
  {
    "name": "Brooklyn",
    "value": 1,
    "lat": -33.5479285,
    "lng": 151.2260175
  },
  {
    "name": "Brookvale",
    "value": 6,
    "lat": -33.7628854,
    "lng": 151.2707024
  },
  {
    "name": "Brownlow Hill",
    "value": 1,
    "lat": -34.0316709,
    "lng": 150.6511051
  },
  {
    "name": "Brunswick",
    "value": 3,
    "lat": -28.538885,
    "lng": 153.5483811
  },
  {
    "name": "Brunswick Heads",
    "value": 2,
    "lat": -28.538885,
    "lng": 153.5483811
  },
  {
    "name": "Bulli",
    "value": 1,
    "lat": -34.3329033,
    "lng": 150.9125015
  },
  {
    "name": "Bundeena",
    "value": 2,
    "lat": -34.0845443,
    "lng": 151.1512348
  },
  {
    "name": "Bungendore",
    "value": 18,
    "lat": -35.2547375,
    "lng": 149.4387166
  },
  {
    "name": "Burraga",
    "value": 1,
    "lat": -33.947552,
    "lng": 149.5296228
  },
  {
    "name": "Burraneer",
    "value": 3,
    "lat": -34.0651643,
    "lng": 151.1328333
  },
  {
    "name": "Burringbar",
    "value": 1,
    "lat": -28.4421662,
    "lng": 153.4333519
  },
  {
    "name": "Burwood",
    "value": 2,
    "lat": -33.8784753,
    "lng": 151.104049
  },
  {
    "name": "Busby",
    "value": 1,
    "lat": -33.915,
    "lng": 150.8844444
  },
  {
    "name": "Byron Bay",
    "value": 33,
    "lat": -28.6483333,
    "lng": 153.6177778
  },
  {
    "name": "Bywong",
    "value": 2,
    "lat": -35.165,
    "lng": 149.3344444
  },
  {
    "name": "Cabramatta",
    "value": 4,
    "lat": -33.8983188,
    "lng": 150.9344502
  },
  {
    "name": "Caddens",
    "value": 12,
    "lat": -33.773603,
    "lng": 150.7288643
  },
  {
    "name": "Calderwood",
    "value": 12,
    "lat": -34.5566667,
    "lng": 150.7427778
  },
  {
    "name": "Calderwood Subdivision",
    "value": 1,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Callaghan",
    "value": 8,
    "lat": -32.8927988,
    "lng": 151.7011832
  },
  {
    "name": "Camden",
    "value": 2,
    "lat": -34.016087,
    "lng": 150.71988490858
  },
  {
    "name": "Camellia",
    "value": 2,
    "lat": -33.8197799,
    "lng": 151.0346488
  },
  {
    "name": "Cameron Park",
    "value": 82,
    "lat": -32.9044444,
    "lng": 151.6091667
  },
  {
    "name": "Cammeray",
    "value": 2,
    "lat": -33.8222738,
    "lng": 151.2139868
  },
  {
    "name": "Campbelltown",
    "value": 8,
    "lat": -34.0636914,
    "lng": 150.8206159
  },
  {
    "name": "Camperdown",
    "value": 7,
    "lat": -33.8896116,
    "lng": 151.1800986
  },
  {
    "name": "Campsie",
    "value": 4,
    "lat": -33.9143894,
    "lng": 151.1032133
  },
  {
    "name": "Caniaba",
    "value": 1,
    "lat": -28.8316667,
    "lng": 153.2344444
  },
  {
    "name": "Canley Heights",
    "value": 1,
    "lat": -33.8816667,
    "lng": 150.9261111
  },
  {
    "name": "Canley Vale",
    "value": 10,
    "lat": -33.8872029,
    "lng": 150.9436605
  },
  {
    "name": "Canley Vale:",
    "value": 1,
    "lat": -33.8872029,
    "lng": 150.9436605
  },
  {
    "name": "Canterbury",
    "value": 11,
    "lat": -33.92389765,
    "lng": 151.06568021163108
  },
  {
    "name": "Canton Beach",
    "value": 1,
    "lat": -33.2733333,
    "lng": 151.5483333
  },
  {
    "name": "Cardiff",
    "value": 3,
    "lat": -32.9525,
    "lng": 151.6622222
  },
  {
    "name": "Caringbah",
    "value": 14,
    "lat": -34.0354477,
    "lng": 151.1248018
  },
  {
    "name": "Caringbah South",
    "value": 5,
    "lat": -34.0354477,
    "lng": 151.1248018
  },
  {
    "name": "Carlingford",
    "value": 12,
    "lat": -33.7744947,
    "lng": 151.0475215
  },
  {
    "name": "Carramar",
    "value": 1,
    "lat": -33.8838889,
    "lng": 150.9636111
  },
  {
    "name": "Carrington",
    "value": 1,
    "lat": -32.9126582,
    "lng": 151.766147
  },
  {
    "name": "Carss Park",
    "value": 2,
    "lat": -33.9869843,
    "lng": 151.1169446
  },
  {
    "name": "Cartwright",
    "value": 1,
    "lat": -33.9250864,
    "lng": 150.8913549
  },
  {
    "name": "Carwoola",
    "value": 1,
    "lat": -35.3697222,
    "lng": 149.3308333
  },
  {
    "name": "Casino",
    "value": 16,
    "lat": -28.8631616,
    "lng": 153.048155
  },
  {
    "name": "Castle Cove",
    "value": 3,
    "lat": -33.7865285,
    "lng": 151.2143187
  },
  {
    "name": "Castle Hill",
    "value": 33,
    "lat": -33.7317524,
    "lng": 151.0069279
  },
  {
    "name": "Castlereagh",
    "value": 4,
    "lat": -31.2185094,
    "lng": 148.4490042
  },
  {
    "name": "Casula",
    "value": 9,
    "lat": -33.9501572,
    "lng": 150.9118445
  },
  {
    "name": "Catherine Field",
    "value": 3,
    "lat": -33.9926657,
    "lng": 150.7650245
  },
  {
    "name": "Catherine Hill Bay",
    "value": 2,
    "lat": -33.1556323,
    "lng": 151.6273518
  },
  {
    "name": "Cattai",
    "value": 1,
    "lat": -33.5482394,
    "lng": 150.9164045
  },
  {
    "name": "Cawdor",
    "value": 1,
    "lat": -34.0902,
    "lng": 150.679
  },
  {
    "name": "Cawongla",
    "value": 1,
    "lat": -28.6005882,
    "lng": 153.0978539
  },
  {
    "name": "Cecil Hills",
    "value": 6,
    "lat": -33.89,
    "lng": 150.8511111
  },
  {
    "name": "Cecil Park",
    "value": 5,
    "lat": -33.8922547,
    "lng": 150.8135524
  },
  {
    "name": "Centennial Park",
    "value": 6,
    "lat": -33.8977778,
    "lng": 151.2338889
  },
  {
    "name": "Cessnock",
    "value": 20,
    "lat": -32.8316667,
    "lng": 151.3511111
  },
  {
    "name": "Charlestown",
    "value": 4,
    "lat": -32.9637018,
    "lng": 151.6937214232309
  },
  {
    "name": "Chatswood",
    "value": 15,
    "lat": -33.7967377,
    "lng": 151.1814306
  },
  {
    "name": "Chatswood West",
    "value": 1,
    "lat": -33.7969658,
    "lng": 151.18363311887097
  },
  {
    "name": "Chester Hill",
    "value": 4,
    "lat": -33.8835449,
    "lng": 150.9994175
  },
  {
    "name": "Chifley",
    "value": 1,
    "lat": -33.9702813,
    "lng": 151.2394867
  },
  {
    "name": "Chippendale",
    "value": 4,
    "lat": -33.8863291,
    "lng": 151.1998211
  },
  {
    "name": "Chipping Norton",
    "value": 10,
    "lat": -33.9040107,
    "lng": 150.9556561863917
  },
  {
    "name": "Chisholm",
    "value": 11,
    "lat": -32.7586741,
    "lng": 151.6343505
  },
  {
    "name": "Chisolm",
    "value": 1,
    "lat": -34.2293539,
    "lng": 150.6847938
  },
  {
    "name": "Chullora",
    "value": 2,
    "lat": -33.8925,
    "lng": 151.0477778
  },
  {
    "name": "Circular Quay",
    "value": 5,
    "lat": -33.8613593,
    "lng": 151.2107193
  },
  {
    "name": "Claremont Meadows",
    "value": 1,
    "lat": -33.7691667,
    "lng": 150.7483333
  },
  {
    "name": "Clarendon",
    "value": 6,
    "lat": -33.6105511,
    "lng": 150.7888909
  },
  {
    "name": "Claymore",
    "value": 2,
    "lat": -34.0469444,
    "lng": 150.81
  },
  {
    "name": "Clontarf",
    "value": 3,
    "lat": -33.8061118,
    "lng": 151.2540508
  },
  {
    "name": "Clovelly",
    "value": 2,
    "lat": -33.9126387,
    "lng": 151.2617904
  },
  {
    "name": "Clyde",
    "value": 1,
    "lat": -33.8359746,
    "lng": 151.017066
  },
  {
    "name": "Coates Dubbo",
    "value": 1,
    "lat": -32.2478964,
    "lng": 148.6026502
  },
  {
    "name": "Cobbitty",
    "value": 6,
    "lat": -34.0104185,
    "lng": 150.6922716
  },
  {
    "name": "Cockatoo Island",
    "value": 2,
    "lat": -33.8475972,
    "lng": 151.1721585033853
  },
  {
    "name": "Coffs Harbour",
    "value": 1,
    "lat": -30.2962407,
    "lng": 153.1135293
  },
  {
    "name": "Colebee",
    "value": 2,
    "lat": -33.7270077,
    "lng": 150.8521783
  },
  {
    "name": "Collaroy",
    "value": 2,
    "lat": -33.7382194,
    "lng": 151.2996618
  },
  {
    "name": "Collaroy Plateau",
    "value": 1,
    "lat": -33.7303841,
    "lng": 151.2910394
  },
  {
    "name": "Colyton",
    "value": 1,
    "lat": -33.7822222,
    "lng": 150.7958333
  },
  {
    "name": "Como",
    "value": 1,
    "lat": -33.995181200000005,
    "lng": 151.07065595033004
  },
  {
    "name": "Concord",
    "value": 19,
    "lat": -33.8556716,
    "lng": 151.1067667
  },
  {
    "name": "Concord West",
    "value": 5,
    "lat": -33.8484033,
    "lng": 151.0856114
  },
  {
    "name": "Condell Park",
    "value": 4,
    "lat": -33.9227893,
    "lng": 151.0113353
  },
  {
    "name": "Connells Point",
    "value": 1,
    "lat": -33.9869476,
    "lng": 151.0942725
  },
  {
    "name": "Coogee",
    "value": 1,
    "lat": -33.9217004,
    "lng": 151.2557975
  },
  {
    "name": "Coolac",
    "value": 3,
    "lat": -34.9257357,
    "lng": 148.1664709
  },
  {
    "name": "Coolangatta",
    "value": 1,
    "lat": -34.8439492,
    "lng": 150.7153999
  },
  {
    "name": "Cooma",
    "value": 7,
    "lat": -36.2356785,
    "lng": 149.1261779
  },
  {
    "name": "Coopers Shoot",
    "value": 1,
    "lat": -28.6816612,
    "lng": 153.5844404
  },
  {
    "name": "Cooranbong",
    "value": 8,
    "lat": -33.0758112,
    "lng": 151.4539993
  },
  {
    "name": "Coraki",
    "value": 4,
    "lat": -28.9868389,
    "lng": 153.2874085
  },
  {
    "name": "Cordeaux Heights",
    "value": 1,
    "lat": -34.4440459,
    "lng": 150.8270128
  },
  {
    "name": "Cornwallis",
    "value": 2,
    "lat": -33.59,
    "lng": 150.8094444
  },
  {
    "name": "Corrimal",
    "value": 2,
    "lat": -34.3757279,
    "lng": 150.9048557
  },
  {
    "name": "Crabbes Creek",
    "value": 1,
    "lat": -28.4567505,
    "lng": 153.4947533
  },
  {
    "name": "Cranebrook",
    "value": 2,
    "lat": -33.7048583,
    "lng": 150.70641
  },
  {
    "name": "Crangan Bay",
    "value": 1,
    "lat": -33.1672353,
    "lng": 151.5957532
  },
  {
    "name": "Cremorne",
    "value": 3,
    "lat": -33.8260081,
    "lng": 151.2254326
  },
  {
    "name": "Crestwood",
    "value": 5,
    "lat": -35.3484121,
    "lng": 149.217538
  },
  {
    "name": "Cringila",
    "value": 1,
    "lat": -34.4670421,
    "lng": 150.8782854
  },
  {
    "name": "Cromer",
    "value": 2,
    "lat": -33.7385227,
    "lng": 151.2762995
  },
  {
    "name": "Cronulla",
    "value": 16,
    "lat": -34.055084050000005,
    "lng": 151.1550223705499
  },
  {
    "name": "Crookwell",
    "value": 2,
    "lat": -34.4576958,
    "lng": 149.4696713
  },
  {
    "name": "Croom",
    "value": 1,
    "lat": -34.59,
    "lng": 150.8261111
  },
  {
    "name": "Crows Nest",
    "value": 1,
    "lat": -33.8256273,
    "lng": 151.2014745
  },
  {
    "name": "Croydon",
    "value": 1,
    "lat": -33.8777935,
    "lng": 151.1156502
  },
  {
    "name": "Croydon Park",
    "value": 3,
    "lat": -33.8975316,
    "lng": 151.1024641
  },
  {
    "name": "Cudgen",
    "value": 4,
    "lat": -28.2734276,
    "lng": 153.5505103
  },
  {
    "name": "Cumballum",
    "value": 1,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Cumbalum",
    "value": 3,
    "lat": -28.8221969,
    "lng": 153.534569
  },
  {
    "name": "Cundletown",
    "value": 2,
    "lat": -31.8816666,
    "lng": 152.5177778
  },
  {
    "name": "Curl Curl",
    "value": 1,
    "lat": -33.7698341,
    "lng": 151.2898175
  },
  {
    "name": "Currawang",
    "value": 2,
    "lat": -34.965,
    "lng": 149.5177778
  },
  {
    "name": "Dapto",
    "value": 1,
    "lat": -34.493037,
    "lng": 150.791789
  },
  {
    "name": "Darling Harbour",
    "value": 6,
    "lat": -33.8675516,
    "lng": 151.1995619
  },
  {
    "name": "Darling Point",
    "value": 1,
    "lat": -34.5659957,
    "lng": 146.0002828
  },
  {
    "name": "Darlinghurst",
    "value": 2,
    "lat": -33.8783381,
    "lng": 151.219225
  },
  {
    "name": "Darlinghurst NSW 2010",
    "value": 1,
    "lat": -33.8783381,
    "lng": 151.219225
  },
  {
    "name": "Darlington",
    "value": 12,
    "lat": -34.5659957,
    "lng": 146.0002828
  },
  {
    "name": "Dean Park",
    "value": 1,
    "lat": -33.7328296,
    "lng": 150.852577
  },
  {
    "name": "Dee Why",
    "value": 4,
    "lat": -33.7526555,
    "lng": 151.2875707
  },
  {
    "name": "Dee why grand centre 15-19 pacific parade Dee why",
    "value": 1,
    "lat": -33.7551131,
    "lng": 151.2854893
  },
  {
    "name": "Denham Court",
    "value": 8,
    "lat": -33.9813889,
    "lng": 150.8294444
  },
  {
    "name": "Denman",
    "value": 2,
    "lat": -32.3895052,
    "lng": 150.6880596
  },
  {
    "name": "Dolls Point",
    "value": 1,
    "lat": -33.9936111,
    "lng": 151.1447222
  },
  {
    "name": "Doonside",
    "value": 1,
    "lat": -33.7549501,
    "lng": 150.8685985
  },
  {
    "name": "Double Bay",
    "value": 9,
    "lat": -33.8766373,
    "lng": 151.24245
  },
  {
    "name": "Dover Heights",
    "value": 5,
    "lat": -33.8739831,
    "lng": 151.2810366
  },
  {
    "name": "Drummoyne",
    "value": 1,
    "lat": -33.8520678,
    "lng": 151.153689
  },
  {
    "name": "Dubbo",
    "value": 2,
    "lat": -32.2478964,
    "lng": 148.6026502
  },
  {
    "name": "Dudley",
    "value": 3,
    "lat": -32.9890099,
    "lng": 151.7192954
  },
  {
    "name": "Dulguigan",
    "value": 1,
    "lat": -28.2783333,
    "lng": 153.4186111
  },
  {
    "name": "Dulwich Hill",
    "value": 5,
    "lat": -33.9045849,
    "lng": 151.1386091
  },
  {
    "name": "Dundas",
    "value": 2,
    "lat": -33.802949,
    "lng": 151.0440587
  },
  {
    "name": "Dundas Valley",
    "value": 3,
    "lat": -33.7936744,
    "lng": 151.0559069
  },
  {
    "name": "Dunmore",
    "value": 1,
    "lat": -34.6057391,
    "lng": 150.8434887
  },
  {
    "name": "Dural",
    "value": 3,
    "lat": -33.6876398,
    "lng": 151.0267199
  },
  {
    "name": "Eagle Vale",
    "value": 3,
    "lat": -34.0377778,
    "lng": 150.8111111
  },
  {
    "name": "Earlwood",
    "value": 2,
    "lat": -33.9247222,
    "lng": 151.1313889
  },
  {
    "name": "East Ballina",
    "value": 2,
    "lat": -28.8595562,
    "lng": 153.5832729
  },
  {
    "name": "East Bowral",
    "value": 1,
    "lat": -34.4994404,
    "lng": 150.4594404
  },
  {
    "name": "East Gosford",
    "value": 2,
    "lat": -33.4316667,
    "lng": 151.3511111
  },
  {
    "name": "East Kangaloon",
    "value": 1,
    "lat": -34.5566667,
    "lng": 150.5677778
  },
  {
    "name": "East Killara",
    "value": 1,
    "lat": -33.7564715,
    "lng": 151.174463
  },
  {
    "name": "East Lindfield",
    "value": 2,
    "lat": -33.7674175,
    "lng": 151.1874672
  },
  {
    "name": "East Lismore",
    "value": 18,
    "lat": -28.8216638,
    "lng": 153.2884783
  },
  {
    "name": "East Maitland",
    "value": 6,
    "lat": -32.7452042,
    "lng": 151.58975550894053
  },
  {
    "name": "East Ryde",
    "value": 1,
    "lat": -33.8097017,
    "lng": 151.1353884
  },
  {
    "name": "Eastern Creek",
    "value": 30,
    "lat": -33.8059423,
    "lng": 150.849956
  },
  {
    "name": "Eastgardens",
    "value": 2,
    "lat": -33.944772,
    "lng": 151.22433012661907
  },
  {
    "name": "Eastwood",
    "value": 7,
    "lat": -33.79,
    "lng": 151.0844444
  },
  {
    "name": "Eden",
    "value": 1,
    "lat": -33.8802849,
    "lng": 150.8762602
  },
  {
    "name": "Edensor Park",
    "value": 2,
    "lat": -33.8802849,
    "lng": 150.8762602
  },
  {
    "name": "Edgecliff",
    "value": 2,
    "lat": -33.8797692,
    "lng": 151.2361116
  },
  {
    "name": "Edgeworth",
    "value": 18,
    "lat": -32.9197222,
    "lng": 151.6311111
  },
  {
    "name": "Edmondson Park",
    "value": 14,
    "lat": -33.9692716,
    "lng": 150.858626
  },
  {
    "name": "Elanora Heights",
    "value": 1,
    "lat": -33.6994613,
    "lng": 151.2750587
  },
  {
    "name": "Elderslie",
    "value": 15,
    "lat": -34.0590289,
    "lng": 150.715403
  },
  {
    "name": "Eleebana",
    "value": 1,
    "lat": -32.9955515,
    "lng": 151.6344322
  },
  {
    "name": "Elermore Vale",
    "value": 1,
    "lat": -32.915,
    "lng": 151.6677778
  },
  {
    "name": "Ellalong",
    "value": 2,
    "lat": -32.914496,
    "lng": 151.3107405
  },
  {
    "name": "Emu Heights",
    "value": 1,
    "lat": -33.7372235,
    "lng": 150.6511051
  },
  {
    "name": "Emu Plains",
    "value": 7,
    "lat": -33.7457008,
    "lng": 150.6715837
  },
  {
    "name": "Enfield",
    "value": 7,
    "lat": -33.8900628,
    "lng": 151.0959145
  },
  {
    "name": "Engadine",
    "value": 10,
    "lat": -34.0650134,
    "lng": 151.0138225
  },
  {
    "name": "Enmore",
    "value": 1,
    "lat": -33.899006299999996,
    "lng": 151.1742479161603
  },
  {
    "name": "Epping",
    "value": 7,
    "lat": -33.7728628,
    "lng": 151.0820902
  },
  {
    "name": "Eraring",
    "value": 2,
    "lat": -33.0625191,
    "lng": 151.51919727791642
  },
  {
    "name": "Ermington",
    "value": 7,
    "lat": -33.8101156,
    "lng": 151.0600559
  },
  {
    "name": "Erskine Park",
    "value": 19,
    "lat": -33.8086111,
    "lng": 150.8013889
  },
  {
    "name": "Erskineville Oval",
    "value": 1,
    "lat": -33.902094500000004,
    "lng": 151.19087142082117
  },
  {
    "name": "Eschol park",
    "value": 2,
    "lat": -34.0316667,
    "lng": 150.8011111
  },
  {
    "name": "Eveleigh",
    "value": 5,
    "lat": -33.895,
    "lng": 151.1913889
  },
  {
    "name": "Ewingsdale",
    "value": 2,
    "lat": -28.6384131,
    "lng": 153.553663
  },
  {
    "name": "Fairfield",
    "value": 7,
    "lat": -33.867440349999995,
    "lng": 150.8893221698039
  },
  {
    "name": "Fairfield East",
    "value": 6,
    "lat": -33.8747423,
    "lng": 150.9721298
  },
  {
    "name": "Fairfield West",
    "value": 5,
    "lat": -33.8667432,
    "lng": 150.92041620015928
  },
  {
    "name": "Fairlight",
    "value": 1,
    "lat": -33.7938789,
    "lng": 151.2741471
  },
  {
    "name": "Fairy Meadow",
    "value": 3,
    "lat": -34.395368,
    "lng": 150.8963847
  },
  {
    "name": "Fassifern",
    "value": 2,
    "lat": -32.9872222,
    "lng": 151.5844444
  },
  {
    "name": "Figtree",
    "value": 4,
    "lat": -34.4307377,
    "lng": 150.8487279
  },
  {
    "name": "Fingal Bay",
    "value": 1,
    "lat": -32.7470423,
    "lng": 152.1687575
  },
  {
    "name": "Five Dock",
    "value": 6,
    "lat": -33.8690024,
    "lng": 151.1290231
  },
  {
    "name": "Forestville",
    "value": 1,
    "lat": -33.7620891,
    "lng": 151.2150889
  },
  {
    "name": "Frenchs Forest",
    "value": 1,
    "lat": -33.7479954,
    "lng": 151.2292718
  },
  {
    "name": "Gables",
    "value": 35,
    "lat": -33.6303326,
    "lng": 150.9031329
  },
  {
    "name": "Galston",
    "value": 5,
    "lat": -33.66133375,
    "lng": 151.04231614721874
  },
  {
    "name": "Garden Suburb",
    "value": 1,
    "lat": -32.9466667,
    "lng": 151.6786111
  },
  {
    "name": "Garie",
    "value": 1,
    "lat": -34.1701298,
    "lng": 151.06810966574358
  },
  {
    "name": "Gateshead",
    "value": 1,
    "lat": -32.9816667,
    "lng": 151.6927778
  },
  {
    "name": "Georges Hall",
    "value": 2,
    "lat": -33.9128804,
    "lng": 150.9824134
  },
  {
    "name": "Georgetown",
    "value": 1,
    "lat": -32.9094444,
    "lng": 151.7319444
  },
  {
    "name": "Ghinni Ghi",
    "value": 1,
    "lat": -28.6235149,
    "lng": 152.7859628
  },
  {
    "name": "Gilead",
    "value": 14,
    "lat": -34.1117863,
    "lng": 150.783942
  },
  {
    "name": "Gillieston Heights",
    "value": 8,
    "lat": -32.7613136,
    "lng": 151.5291563
  },
  {
    "name": "Girards Hill",
    "value": 13,
    "lat": -28.817496,
    "lng": 153.2783319
  },
  {
    "name": "Girraween",
    "value": 3,
    "lat": -33.7983305,
    "lng": 150.9427707
  },
  {
    "name": "Girvan",
    "value": 1,
    "lat": -32.4775,
    "lng": 152.065
  },
  {
    "name": "Gladesville",
    "value": 2,
    "lat": -33.8275,
    "lng": 151.1263889
  },
  {
    "name": "Glebe",
    "value": 7,
    "lat": -33.8777782,
    "lng": 151.1862377
  },
  {
    "name": "Gledswood Hills",
    "value": 14,
    "lat": -34.0102826,
    "lng": 150.78002
  },
  {
    "name": "Glen Alpine",
    "value": 1,
    "lat": -34.09,
    "lng": 150.7844444
  },
  {
    "name": "Glenbrook",
    "value": 2,
    "lat": -33.762521500000005,
    "lng": 150.63603123640593
  },
  {
    "name": "Glendenning",
    "value": 4,
    "lat": -33.7483333,
    "lng": 150.8511111
  },
  {
    "name": "Glenfield",
    "value": 4,
    "lat": -33.9722422,
    "lng": 150.8930882
  },
  {
    "name": "Glenfield NSW",
    "value": 1,
    "lat": -33.9722422,
    "lng": 150.8930882
  },
  {
    "name": "Glenhaven",
    "value": 4,
    "lat": -33.7027383,
    "lng": 151.0008049
  },
  {
    "name": "Glenmore Park",
    "value": 7,
    "lat": -33.791012699999996,
    "lng": 150.67254279233066
  },
  {
    "name": "Glenwood",
    "value": 1,
    "lat": -33.7331483,
    "lng": 150.928232
  },
  {
    "name": "Glenworth Valley",
    "value": 1,
    "lat": -33.415,
    "lng": 151.1844444
  },
  {
    "name": "Gloucester",
    "value": 1,
    "lat": -32.0572002,
    "lng": 151.8608568
  },
  {
    "name": "Googong",
    "value": 46,
    "lat": -35.4204417,
    "lng": 149.26242916735706
  },
  {
    "name": "Goolmangar",
    "value": 1,
    "lat": -28.7391667,
    "lng": 153.2405556
  },
  {
    "name": "Goonellabah",
    "value": 20,
    "lat": -28.815,
    "lng": 153.3177777
  },
  {
    "name": "Gordon",
    "value": 3,
    "lat": -33.7557991,
    "lng": 151.1543302
  },
  {
    "name": "Gorokan",
    "value": 1,
    "lat": -33.2562494,
    "lng": 151.5140288
  },
  {
    "name": "Gosford",
    "value": 4,
    "lat": -33.4240979,
    "lng": 151.3411475
  },
  {
    "name": "Goulburn",
    "value": 17,
    "lat": -34.7523871,
    "lng": 149.7198009
  },
  {
    "name": "Grafton",
    "value": 13,
    "lat": -29.6816773,
    "lng": 152.9336357
  },
  {
    "name": "Grantham Farm",
    "value": 10,
    "lat": -33.6630125,
    "lng": 150.8726952
  },
  {
    "name": "Granville",
    "value": 1,
    "lat": -33.8345097,
    "lng": 151.0060111
  },
  {
    "name": "Grasmere",
    "value": 1,
    "lat": -34.0579584,
    "lng": 150.6707384
  },
  {
    "name": "Green Valley",
    "value": 3,
    "lat": -33.9024601,
    "lng": 150.8674187
  },
  {
    "name": "Greenacres",
    "value": 1,
    "lat": -33.36186115393438,
    "lng": 151.417377984021
  },
  {
    "name": "Greenfield Park",
    "value": 1,
    "lat": -33.8752778,
    "lng": 150.8919444
  },
  {
    "name": "Greenleigh",
    "value": 3,
    "lat": -35.3663849,
    "lng": 149.2514741
  },
  {
    "name": "Greenridge",
    "value": 1,
    "lat": -28.8983333,
    "lng": 153.1177778
  },
  {
    "name": "Greenwich",
    "value": 3,
    "lat": -33.8300104,
    "lng": 151.1855621
  },
  {
    "name": "Gregadoo",
    "value": 2,
    "lat": -35.2316667,
    "lng": 147.4177778
  },
  {
    "name": "Gregory Hills",
    "value": 4,
    "lat": -34.0276788,
    "lng": 150.776302
  },
  {
    "name": "Greta",
    "value": 1,
    "lat": -32.6866741,
    "lng": 151.3841142
  },
  {
    "name": "Greystanes",
    "value": 19,
    "lat": -33.8127801,
    "lng": 150.9402976720001
  },
  {
    "name": "Greystanes NSW 2145",
    "value": 1,
    "lat": -33.8127801,
    "lng": 150.9402977
  },
  {
    "name": "Guildford",
    "value": 5,
    "lat": -33.8561049,
    "lng": 150.9939232
  },
  {
    "name": "Guildford West",
    "value": 7,
    "lat": -33.8464576,
    "lng": 150.9695258418221
  },
  {
    "name": "Guilford",
    "value": 1,
    "lat": -33.8746936,
    "lng": 151.1809261
  },
  {
    "name": "Gulmarrad",
    "value": 1,
    "lat": -29.49,
    "lng": 153.2344444
  },
  {
    "name": "Gundaroo",
    "value": 2,
    "lat": -35.0252793,
    "lng": 149.267271
  },
  {
    "name": "Gunning",
    "value": 1,
    "lat": -34.7831232,
    "lng": 149.2659887
  },
  {
    "name": "Gurrundah",
    "value": 1,
    "lat": -34.6608333,
    "lng": 149.4066667
  },
  {
    "name": "Guthega",
    "value": 1,
    "lat": -36.378988899999996,
    "lng": 148.37090464600988
  },
  {
    "name": "Gymea",
    "value": 3,
    "lat": -34.0522918,
    "lng": 151.0970783
  },
  {
    "name": "Gymea Bay",
    "value": 2,
    "lat": -34.0522918,
    "lng": 151.0970783
  },
  {
    "name": "Haberfield",
    "value": 2,
    "lat": -33.8794325,
    "lng": 151.1391605
  },
  {
    "name": "Halloran",
    "value": 1,
    "lat": -33.2302778,
    "lng": 151.4391667
  },
  {
    "name": "Hamilton",
    "value": 2,
    "lat": -32.9186415,
    "lng": 151.7487447
  },
  {
    "name": "Hamilton East",
    "value": 1,
    "lat": -32.9247222,
    "lng": 151.7538889
  },
  {
    "name": "Hamilton North",
    "value": 1,
    "lat": -32.915,
    "lng": 151.7358333
  },
  {
    "name": "Hamilton South",
    "value": 1,
    "lat": -32.9334617,
    "lng": 151.7477832
  },
  {
    "name": "Hamlyn Terrace",
    "value": 4,
    "lat": -33.2544444,
    "lng": 151.4727778
  },
  {
    "name": "Hampton",
    "value": 1,
    "lat": -33.6483333,
    "lng": 150.0511111
  },
  {
    "name": "Hastings Point",
    "value": 1,
    "lat": -28.3638889,
    "lng": 153.5747222
  },
  {
    "name": "Haymarket",
    "value": 5,
    "lat": -33.8814408,
    "lng": 151.2044524
  },
  {
    "name": "Haywards Bay",
    "value": 1,
    "lat": -34.545,
    "lng": 150.7941667
  },
  {
    "name": "Heathcote",
    "value": 5,
    "lat": -34.12725035,
    "lng": 150.97338112186077
  },
  {
    "name": "Heatherbrae",
    "value": 5,
    "lat": -32.7816614,
    "lng": 151.7344368
  },
  {
    "name": "Heddon Greta",
    "value": 1,
    "lat": -32.8034947,
    "lng": 151.5106161
  },
  {
    "name": "Helensburgh",
    "value": 3,
    "lat": -34.1908519,
    "lng": 150.9822187
  },
  {
    "name": "Hill Top",
    "value": 1,
    "lat": -30.13752,
    "lng": 142.84146
  },
  {
    "name": "Hillsdale",
    "value": 7,
    "lat": -33.9529465,
    "lng": 151.2274123
  },
  {
    "name": "Hinchinbrook",
    "value": 1,
    "lat": -33.9159661,
    "lng": 150.8645957
  },
  {
    "name": "Hobartville",
    "value": 5,
    "lat": -33.604718,
    "lng": 150.7436152
  },
  {
    "name": "Holgate",
    "value": 1,
    "lat": -33.4066667,
    "lng": 151.4094444
  },
  {
    "name": "Holmesville",
    "value": 3,
    "lat": -32.9151122,
    "lng": 151.5782856
  },
  {
    "name": "Holsworthy",
    "value": 1,
    "lat": -33.9938416,
    "lng": 150.95104
  },
  {
    "name": "Homebush",
    "value": 3,
    "lat": -33.8306908,
    "lng": 151.0805789
  },
  {
    "name": "Homebush West",
    "value": 3,
    "lat": -33.8619802,
    "lng": 151.0665026
  },
  {
    "name": "Horningsea Park",
    "value": 1,
    "lat": -33.9460804,
    "lng": 150.8432271
  },
  {
    "name": "Hornsby",
    "value": 7,
    "lat": -33.7040253,
    "lng": 151.1005847
  },
  {
    "name": "Hornsby Heights",
    "value": 2,
    "lat": -33.6630602,
    "lng": 151.1021935
  },
  {
    "name": "Horsley",
    "value": 1,
    "lat": -34.49,
    "lng": 150.7761111
  },
  {
    "name": "Horsley Drive",
    "value": 10,
    "lat": -34.48781045,
    "lng": 150.77978589440482
  },
  {
    "name": "Horsley Park",
    "value": 36,
    "lat": -33.8387723,
    "lng": 150.8484629
  },
  {
    "name": "Horsley Park.",
    "value": 1,
    "lat": -33.8387723,
    "lng": 150.8484629
  },
  {
    "name": "Hunters Hill",
    "value": 1,
    "lat": -33.82989005,
    "lng": 151.13600450197953
  },
  {
    "name": "Huntingwood",
    "value": 3,
    "lat": -33.797973,
    "lng": 150.881592
  },
  {
    "name": "Huntlee",
    "value": 5,
    "lat": -32.6706573,
    "lng": 151.3512361
  },
  {
    "name": "Huntley",
    "value": 2,
    "lat": -34.4963889,
    "lng": 150.7358333
  },
  {
    "name": "Hurlstone Park",
    "value": 5,
    "lat": -33.9105924,
    "lng": 151.1317928
  },
  {
    "name": "Hurstville",
    "value": 6,
    "lat": -33.9612886,
    "lng": 151.09931781316638
  },
  {
    "name": "Illawong",
    "value": 2,
    "lat": -33.9973348,
    "lng": 151.0429726
  },
  {
    "name": "Ingleburn",
    "value": 5,
    "lat": -33.9983333,
    "lng": 150.8511111
  },
  {
    "name": "Ingleside",
    "value": 2,
    "lat": -33.6828279,
    "lng": 151.261556
  },
  {
    "name": "Jamberoo",
    "value": 2,
    "lat": -34.6470241,
    "lng": 150.7762599
  },
  {
    "name": "JamisonTown",
    "value": 8,
    "lat": -33.7679769,
    "lng": 150.674815
  },
  {
    "name": "Jannali",
    "value": 1,
    "lat": -34.0163159,
    "lng": 151.0658096
  },
  {
    "name": "Jeir",
    "value": 1,
    "lat": -35.0530511,
    "lng": 148.98
  },
  {
    "name": "Jerrabomberra",
    "value": 19,
    "lat": -35.4225092,
    "lng": 149.1894004
  },
  {
    "name": "Jervis Bay",
    "value": 2,
    "lat": -34.957168949999996,
    "lng": 150.74270894093422
  },
  {
    "name": "Jervis Bay Village",
    "value": 2,
    "lat": -34.957168949999996,
    "lng": 150.74270894093422
  },
  {
    "name": "Jesmond",
    "value": 8,
    "lat": -32.9036111,
    "lng": 151.6941667
  },
  {
    "name": "Jilliby",
    "value": 4,
    "lat": -33.2483333,
    "lng": 151.3844444
  },
  {
    "name": "Jindabyne",
    "value": 3,
    "lat": -36.4170899,
    "lng": 148.61996
  },
  {
    "name": "Jordan Springs",
    "value": 16,
    "lat": -33.7250215,
    "lng": 150.7271271
  },
  {
    "name": "KINGS PARK",
    "value": 1,
    "lat": -33.7433333,
    "lng": 150.9086111
  },
  {
    "name": "Kanahooka",
    "value": 1,
    "lat": -34.494564249999996,
    "lng": 150.805346953227
  },
  {
    "name": "Karabar",
    "value": 1,
    "lat": -35.3759426,
    "lng": 149.2328718
  },
  {
    "name": "Kareela",
    "value": 2,
    "lat": -34.0157553,
    "lng": 151.0812662
  },
  {
    "name": "Katoomba",
    "value": 1,
    "lat": -33.713759,
    "lng": 150.3121633
  },
  {
    "name": "Kearsley",
    "value": 2,
    "lat": -32.8608303,
    "lng": 151.3977745
  },
  {
    "name": "Keiraville",
    "value": 1,
    "lat": -34.4092539,
    "lng": 150.8729729
  },
  {
    "name": "Kellyville",
    "value": 20,
    "lat": -33.7158272,
    "lng": 150.954993
  },
  {
    "name": "Kellyville Ridge",
    "value": 2,
    "lat": -33.7025,
    "lng": 150.9186111
  },
  {
    "name": "Kembla Grange",
    "value": 4,
    "lat": -34.470167,
    "lng": 150.8175203
  },
  {
    "name": "Kemps Creek",
    "value": 62,
    "lat": -33.8813335,
    "lng": 150.7837238
  },
  {
    "name": "Kensignton",
    "value": 1,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Kensington",
    "value": 13,
    "lat": -33.91701725,
    "lng": 151.2251677447594
  },
  {
    "name": "Kenthurst",
    "value": 2,
    "lat": -33.6436678,
    "lng": 150.9761716
  },
  {
    "name": "Kentlyn",
    "value": 1,
    "lat": -34.0591667,
    "lng": 150.8697222
  },
  {
    "name": "Kielvale",
    "value": 1,
    "lat": -28.3336032,
    "lng": 153.43343
  },
  {
    "name": "Kilaben Bay",
    "value": 1,
    "lat": -33.0261111,
    "lng": 151.5927778
  },
  {
    "name": "Killara",
    "value": 7,
    "lat": -33.7660606,
    "lng": 151.1601121
  },
  {
    "name": "Killarney Heights",
    "value": 1,
    "lat": -33.7751234,
    "lng": 151.2181136
  },
  {
    "name": "Kincumber",
    "value": 3,
    "lat": -33.481853,
    "lng": 151.3822781
  },
  {
    "name": "Kings Forest",
    "value": 1,
    "lat": -28.2972232,
    "lng": 153.5483234
  },
  {
    "name": "Kings Langley",
    "value": 1,
    "lat": -33.7505506,
    "lng": 150.9372174
  },
  {
    "name": "Kings Langley NSW",
    "value": 1,
    "lat": -33.7505506,
    "lng": 150.9372174
  },
  {
    "name": "Kingscliff",
    "value": 4,
    "lat": -28.2566667,
    "lng": 153.5761111
  },
  {
    "name": "Kingsford",
    "value": 2,
    "lat": -33.9498935,
    "lng": 151.18196819346016
  },
  {
    "name": "Kingsgrove",
    "value": 4,
    "lat": -33.9371844,
    "lng": 151.0996523
  },
  {
    "name": "Kingswood",
    "value": 8,
    "lat": -33.7613772,
    "lng": 150.7213283
  },
  {
    "name": "Kinvara",
    "value": 1,
    "lat": -28.7907168,
    "lng": 153.5451364
  },
  {
    "name": "Kirrawee",
    "value": 6,
    "lat": -34.0344781,
    "lng": 151.0726428
  },
  {
    "name": "Kirribilli",
    "value": 2,
    "lat": -33.8513124,
    "lng": 151.21912475755968
  },
  {
    "name": "Kirribilli NSW",
    "value": 1,
    "lat": -33.8513124,
    "lng": 151.2191248
  },
  {
    "name": "Kogarah",
    "value": 6,
    "lat": -33.968226,
    "lng": 151.1354509
  },
  {
    "name": "Kooragang",
    "value": 4,
    "lat": -32.8761111,
    "lng": 151.7677778
  },
  {
    "name": "Kotara",
    "value": 2,
    "lat": -32.9413898,
    "lng": 151.6985472
  },
  {
    "name": "Kotara South",
    "value": 2,
    "lat": -32.9413898,
    "lng": 151.6985472
  },
  {
    "name": "Kurnell",
    "value": 10,
    "lat": -34.0222379,
    "lng": 151.1880555
  },
  {
    "name": "Kurri Kurri",
    "value": 8,
    "lat": -32.8175039,
    "lng": 151.4833649
  },
  {
    "name": "Kyogle",
    "value": 12,
    "lat": -28.64629175,
    "lng": 152.7444244147487
  },
  {
    "name": "La Perouse",
    "value": 7,
    "lat": -33.9886291,
    "lng": 151.2320796
  },
  {
    "name": "Lake Albert",
    "value": 1,
    "lat": -35.1659335,
    "lng": 147.3821008
  },
  {
    "name": "Lake Heights",
    "value": 1,
    "lat": -34.4843238,
    "lng": 150.8671817
  },
  {
    "name": "Lake Illawarra",
    "value": 1,
    "lat": -34.5225021,
    "lng": 150.840466
  },
  {
    "name": "Lake Munmorah",
    "value": 2,
    "lat": -33.2145467,
    "lng": 151.5697213
  },
  {
    "name": "Lakemba",
    "value": 9,
    "lat": -33.9196311,
    "lng": 151.0749236
  },
  {
    "name": "Lalor Park",
    "value": 2,
    "lat": -33.7649937,
    "lng": 150.9288833
  },
  {
    "name": "Lambton",
    "value": 7,
    "lat": -32.9179825,
    "lng": 151.72206748182944
  },
  {
    "name": "Lane Cove",
    "value": 5,
    "lat": -33.8232026,
    "lng": 151.16971475129134
  },
  {
    "name": "Lane Cove North",
    "value": 2,
    "lat": -33.76068795,
    "lng": 151.10539634999998
  },
  {
    "name": "Lane Cove West",
    "value": 4,
    "lat": -33.80535527505188,
    "lng": 151.15144438300445
  },
  {
    "name": "Lansvale",
    "value": 4,
    "lat": -33.9003985,
    "lng": 150.9510782
  },
  {
    "name": "Leichhardt",
    "value": 1,
    "lat": -33.8819328,
    "lng": 151.155867
  },
  {
    "name": "Len Waters Estate",
    "value": 4,
    "lat": -33.9146,
    "lng": 150.8532
  },
  {
    "name": "Lennox Head",
    "value": 12,
    "lat": -28.7910334,
    "lng": 153.5878047
  },
  {
    "name": "Leppington",
    "value": 31,
    "lat": -33.9543857,
    "lng": 150.80806378606871
  },
  {
    "name": "Leumeah",
    "value": 1,
    "lat": -34.0543113,
    "lng": 150.8371354
  },
  {
    "name": "Lewisham",
    "value": 3,
    "lat": -33.8953868,
    "lng": 151.1466449
  },
  {
    "name": "Liberty Grove",
    "value": 1,
    "lat": -33.8413889,
    "lng": 151.0838889
  },
  {
    "name": "Lidcombe",
    "value": 13,
    "lat": -33.8638146,
    "lng": 151.0452428
  },
  {
    "name": "Lillian Rock",
    "value": 2,
    "lat": -28.5316667,
    "lng": 153.1511111
  },
  {
    "name": "Lilyfield",
    "value": 5,
    "lat": -33.8709879,
    "lng": 151.1616185
  },
  {
    "name": "Lindendale",
    "value": 1,
    "lat": -28.8316667,
    "lng": 153.3844444
  },
  {
    "name": "Lindfield",
    "value": 1,
    "lat": -33.775698,
    "lng": 151.1688652
  },
  {
    "name": "Lismore",
    "value": 70,
    "lat": -28.8077608,
    "lng": 153.2791883
  },
  {
    "name": "Lismore Heights",
    "value": 2,
    "lat": -28.8044444,
    "lng": 153.3
  },
  {
    "name": "Little Bay",
    "value": 2,
    "lat": -33.9834309,
    "lng": 151.2470329
  },
  {
    "name": "Little Hartley",
    "value": 3,
    "lat": -33.5666032,
    "lng": 150.2067338
  },
  {
    "name": "Liverpool",
    "value": 17,
    "lat": -33.9198252,
    "lng": 150.92566
  },
  {
    "name": "Llandilo",
    "value": 1,
    "lat": -33.7069918,
    "lng": 150.7500242
  },
  {
    "name": "Lochinvar",
    "value": 7,
    "lat": -32.720522,
    "lng": 151.4502162
  },
  {
    "name": "Loftus",
    "value": 2,
    "lat": -34.0453436,
    "lng": 151.0513461
  },
  {
    "name": "Loftville",
    "value": 1,
    "lat": -28.83699225,
    "lng": 153.26112799327308
  },
  {
    "name": "Londonderry",
    "value": 1,
    "lat": -33.6483333,
    "lng": 150.7344444
  },
  {
    "name": "Longueville",
    "value": 1,
    "lat": -33.8291667,
    "lng": 151.1686111
  },
  {
    "name": "Lower Portland",
    "value": 1,
    "lat": -33.4316667,
    "lng": 150.8844444
  },
  {
    "name": "Lucas Heights",
    "value": 1,
    "lat": -34.0516667,
    "lng": 150.9847222
  },
  {
    "name": "Luddenham",
    "value": 13,
    "lat": -33.8779831,
    "lng": 150.6901151
  },
  {
    "name": "Lugarno",
    "value": 5,
    "lat": -33.9823958,
    "lng": 151.0450193
  },
  {
    "name": "Lurnea",
    "value": 12,
    "lat": -33.9358333,
    "lng": 150.8972222
  },
  {
    "name": "Macquarie",
    "value": 1,
    "lat": -31.4299499,
    "lng": 152.9103525
  },
  {
    "name": "Macquarie Fields",
    "value": 2,
    "lat": -33.9847895,
    "lng": 150.8789007
  },
  {
    "name": "Macquarie Links",
    "value": 1,
    "lat": -33.9816667,
    "lng": 150.8733333
  },
  {
    "name": "Macquarie Park",
    "value": 8,
    "lat": -33.774197,
    "lng": 151.1127326987788
  },
  {
    "name": "Macquarie University",
    "value": 2,
    "lat": -33.774197,
    "lng": 151.1127326987788
  },
  {
    "name": "Maitland",
    "value": 1,
    "lat": -32.7316683,
    "lng": 151.5511123
  },
  {
    "name": "Mallanganee",
    "value": 1,
    "lat": -28.9060362,
    "lng": 152.7584786
  },
  {
    "name": "Manly",
    "value": 8,
    "lat": -33.7971937,
    "lng": 151.2879845
  },
  {
    "name": "Manly Vale",
    "value": 2,
    "lat": -33.7830838,
    "lng": 151.2659938
  },
  {
    "name": "Maraylya",
    "value": 1,
    "lat": -33.5913984,
    "lng": 150.9221281
  },
  {
    "name": "Marayong",
    "value": 1,
    "lat": -33.7491667,
    "lng": 150.8919444
  },
  {
    "name": "Marmong Point",
    "value": 1,
    "lat": -32.9816667,
    "lng": 151.6177778
  },
  {
    "name": "Maroubra",
    "value": 14,
    "lat": -33.9453441,
    "lng": 151.2456824
  },
  {
    "name": "Marrickville",
    "value": 19,
    "lat": -33.9104,
    "lng": 151.1560775
  },
  {
    "name": "Marsden Park",
    "value": 18,
    "lat": -33.6956552,
    "lng": 150.8147975
  },
  {
    "name": "Marsfield",
    "value": 4,
    "lat": -33.7777956,
    "lng": 151.1032015
  },
  {
    "name": "Marshall Mount",
    "value": 2,
    "lat": -34.5441667,
    "lng": 150.7372222
  },
  {
    "name": "Marton Park Kurnell",
    "value": 1,
    "lat": -34.0115017,
    "lng": 151.211625
  },
  {
    "name": "Marulan",
    "value": 1,
    "lat": -34.7111747,
    "lng": 150.0064012
  },
  {
    "name": "Maryland",
    "value": 7,
    "lat": -28.5351492,
    "lng": 152.1993066
  },
  {
    "name": "Maryvale",
    "value": 1,
    "lat": -32.4710187,
    "lng": 148.9098879
  },
  {
    "name": "Maryville",
    "value": 6,
    "lat": -32.9115947,
    "lng": 151.7552066
  },
  {
    "name": "Mascot",
    "value": 27,
    "lat": -33.9289562,
    "lng": 151.1951782
  },
  {
    "name": "Matraville",
    "value": 7,
    "lat": -33.9639325,
    "lng": 151.2334198
  },
  {
    "name": "Mayfeild",
    "value": 1,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Mayfield",
    "value": 7,
    "lat": -32.8983333,
    "lng": 151.7344444
  },
  {
    "name": "Mayfield North",
    "value": 8,
    "lat": -32.89,
    "lng": 151.7427778
  },
  {
    "name": "Mayfield West",
    "value": 2,
    "lat": -32.890084,
    "lng": 151.7262824
  },
  {
    "name": "Mays Hill",
    "value": 1,
    "lat": -33.8205758,
    "lng": 150.9884915
  },
  {
    "name": "McGraths Hill",
    "value": 3,
    "lat": -33.615,
    "lng": 150.8344444
  },
  {
    "name": "McLeans Ridges",
    "value": 1,
    "lat": -28.7985,
    "lng": 153.3846
  },
  {
    "name": "McMahons Point",
    "value": 1,
    "lat": -33.8443387,
    "lng": 151.2027957
  },
  {
    "name": "Meadowbank",
    "value": 2,
    "lat": -33.8174993,
    "lng": 151.0884249
  },
  {
    "name": "Medlow Bath",
    "value": 5,
    "lat": -33.6743171,
    "lng": 150.2825889
  },
  {
    "name": "Medowie",
    "value": 7,
    "lat": -32.7316667,
    "lng": 151.8511111
  },
  {
    "name": "Melonba",
    "value": 32,
    "lat": -33.6980014,
    "lng": 150.7953576
  },
  {
    "name": "Melrose Park",
    "value": 15,
    "lat": -33.8153435,
    "lng": 151.0733298
  },
  {
    "name": "Menai",
    "value": 3,
    "lat": -34.014811,
    "lng": 151.0164823
  },
  {
    "name": "Menangle Park",
    "value": 9,
    "lat": -34.103653,
    "lng": 150.7449641
  },
  {
    "name": "Menangle Village",
    "value": 1,
    "lat": -34.133157999999995,
    "lng": 150.73860766386866
  },
  {
    "name": "Merewether",
    "value": 7,
    "lat": -32.9293072,
    "lng": 151.73505140840285
  },
  {
    "name": "Merewether Heights",
    "value": 1,
    "lat": -32.9469149,
    "lng": 151.7317937
  },
  {
    "name": "Merrylands",
    "value": 8,
    "lat": -33.8409275,
    "lng": 150.96957601502282
  },
  {
    "name": "Middle Cove",
    "value": 1,
    "lat": -33.7927992,
    "lng": 151.2112471
  },
  {
    "name": "Middle Dural",
    "value": 1,
    "lat": -33.6367412,
    "lng": 151.0127369
  },
  {
    "name": "Middleton Grange",
    "value": 3,
    "lat": -33.9147154,
    "lng": 150.8423882
  },
  {
    "name": "Milbrodale",
    "value": 1,
    "lat": -32.6962212,
    "lng": 151.005395
  },
  {
    "name": "Miller",
    "value": 6,
    "lat": -33.87701305,
    "lng": 150.99278004904286
  },
  {
    "name": "Milperra",
    "value": 20,
    "lat": -33.9388237,
    "lng": 150.9846424
  },
  {
    "name": "Milsons Point",
    "value": 3,
    "lat": -33.8458627,
    "lng": 151.2117909
  },
  {
    "name": "Milton",
    "value": 3,
    "lat": -35.3169793,
    "lng": 150.4375645
  },
  {
    "name": "Minchinbury",
    "value": 6,
    "lat": -33.7866731,
    "lng": 150.8272222
  },
  {
    "name": "Minmi",
    "value": 2,
    "lat": -32.8794277,
    "lng": 151.6180731
  },
  {
    "name": "Minnamurra",
    "value": 2,
    "lat": -34.63396776651122,
    "lng": 150.73297097563662
  },
  {
    "name": "Minto",
    "value": 11,
    "lat": -34.0316667,
    "lng": 150.8511111
  },
  {
    "name": "Miranda",
    "value": 9,
    "lat": -34.0335434,
    "lng": 151.1037193
  },
  {
    "name": "Mittagong",
    "value": 2,
    "lat": -34.4500664,
    "lng": 150.4473469
  },
  {
    "name": "Modanville",
    "value": 1,
    "lat": -28.7152,
    "lng": 153.3012
  },
  {
    "name": "Mollymook",
    "value": 2,
    "lat": -35.3418893,
    "lng": 150.4704386
  },
  {
    "name": "Monaltrie",
    "value": 1,
    "lat": -28.8541,
    "lng": 153.2901
  },
  {
    "name": "Monterey",
    "value": 1,
    "lat": -33.9720137,
    "lng": 151.1480392
  },
  {
    "name": "Mooney Mooney",
    "value": 2,
    "lat": -33.5238945,
    "lng": 151.203356
  },
  {
    "name": "Moore Park",
    "value": 19,
    "lat": -33.8958333,
    "lng": 151.2219444
  },
  {
    "name": "Moore Park NSW 2021",
    "value": 29,
    "lat": -33.8958333,
    "lng": 151.2219444
  },
  {
    "name": "Moorebank",
    "value": 36,
    "lat": -33.9332633,
    "lng": 150.949686
  },
  {
    "name": "Morisset",
    "value": 14,
    "lat": -33.1090883,
    "lng": 151.4879121
  },
  {
    "name": "Mortdale",
    "value": 3,
    "lat": -33.9708469,
    "lng": 151.0811258
  },
  {
    "name": "Mortlake",
    "value": 1,
    "lat": -33.8410416,
    "lng": 151.1061114
  },
  {
    "name": "Morundah",
    "value": 4,
    "lat": -34.9350435,
    "lng": 146.301582
  },
  {
    "name": "Mosman",
    "value": 20,
    "lat": -33.8301355,
    "lng": 151.2447663
  },
  {
    "name": "Moss Vale",
    "value": 3,
    "lat": -34.7275495,
    "lng": 150.5209253
  },
  {
    "name": "Mount Annan",
    "value": 4,
    "lat": -34.0692578,
    "lng": 150.77088550251023
  },
  {
    "name": "Mount Colah",
    "value": 1,
    "lat": -33.6719686,
    "lng": 151.1145291
  },
  {
    "name": "Mount Druitt",
    "value": 5,
    "lat": -33.7705556,
    "lng": 150.8205556
  },
  {
    "name": "Mount Hunter Rivulet",
    "value": 1,
    "lat": -34.0383887,
    "lng": 150.6444878
  },
  {
    "name": "Mount Hutton",
    "value": 2,
    "lat": -32.9816667,
    "lng": 151.6705556
  },
  {
    "name": "Mount Kuring-gai",
    "value": 2,
    "lat": -33.6531707,
    "lng": 151.1368681
  },
  {
    "name": "Mount Olive",
    "value": 1,
    "lat": -32.3818,
    "lng": 151.2179
  },
  {
    "name": "Mount Ousley",
    "value": 4,
    "lat": -34.400779,
    "lng": 150.8803636
  },
  {
    "name": "Mount Pritchard",
    "value": 2,
    "lat": -33.9027189,
    "lng": 150.9031488
  },
  {
    "name": "Mount Riverview",
    "value": 2,
    "lat": -33.7316997,
    "lng": 150.6307053
  },
  {
    "name": "Mount Vernon",
    "value": 1,
    "lat": -33.8566667,
    "lng": 150.8094444
  },
  {
    "name": "Mount Warrigal",
    "value": 1,
    "lat": -34.5483333,
    "lng": 150.8427778
  },
  {
    "name": "Mullumbimby",
    "value": 3,
    "lat": -28.5483333,
    "lng": 153.5011111
  },
  {
    "name": "Murrumbateman",
    "value": 5,
    "lat": -34.9684976,
    "lng": 149.0280817
  },
  {
    "name": "Murwillumbah",
    "value": 4,
    "lat": -28.3267617,
    "lng": 153.3971541
  },
  {
    "name": "Muswellbrook",
    "value": 5,
    "lat": -32.2652323,
    "lng": 150.888733
  },
  {
    "name": "Myuna Bay",
    "value": 2,
    "lat": -33.0622222,
    "lng": 151.5455556
  },
  {
    "name": "Narellan",
    "value": 2,
    "lat": -34.0419063,
    "lng": 150.7376955
  },
  {
    "name": "Naremburn",
    "value": 1,
    "lat": -33.8172735,
    "lng": 151.2012204
  },
  {
    "name": "Narrabeen",
    "value": 1,
    "lat": -33.7135699,
    "lng": 151.2978164
  },
  {
    "name": "Naughtons Gap",
    "value": 1,
    "lat": -28.7983333,
    "lng": 153.1011111
  },
  {
    "name": "Nelson Bay",
    "value": 3,
    "lat": -32.7218138,
    "lng": 152.1440889
  },
  {
    "name": "Nelson Bay NSW",
    "value": 1,
    "lat": -32.7218138,
    "lng": 152.1440889
  },
  {
    "name": "Neutral Bay",
    "value": 4,
    "lat": -33.8342887,
    "lng": 151.2182049
  },
  {
    "name": "New Italy",
    "value": 1,
    "lat": -29.1318,
    "lng": 153.2679
  },
  {
    "name": "New Lambton",
    "value": 4,
    "lat": -32.9277778,
    "lng": 151.7108333
  },
  {
    "name": "New Lambton Heights",
    "value": 3,
    "lat": -32.9262186,
    "lng": 151.6983396
  },
  {
    "name": "New Park",
    "value": 2,
    "lat": -30.595492450000002,
    "lng": 152.4697192170769
  },
  {
    "name": "Newcastle",
    "value": 9,
    "lat": -32.9192953,
    "lng": 151.7795348
  },
  {
    "name": "Newcastle West",
    "value": 6,
    "lat": -32.9286111,
    "lng": 151.76
  },
  {
    "name": "Newington",
    "value": 2,
    "lat": -33.8979162,
    "lng": 151.163191
  },
  {
    "name": "Newport",
    "value": 1,
    "lat": -33.6591061,
    "lng": 151.3164331
  },
  {
    "name": "Newrybar",
    "value": 2,
    "lat": -28.715,
    "lng": 153.5344444
  },
  {
    "name": "Newtown",
    "value": 4,
    "lat": -33.8961132,
    "lng": 151.1801893
  },
  {
    "name": "Nimbin",
    "value": 7,
    "lat": -28.5940455,
    "lng": 153.2229752
  },
  {
    "name": "Nirimba Fields",
    "value": 11,
    "lat": -33.7180087,
    "lng": 150.8714368
  },
  {
    "name": "Noraville",
    "value": 1,
    "lat": -33.2643752,
    "lng": 151.5581978
  },
  {
    "name": "Normanhurst",
    "value": 2,
    "lat": -33.72132115,
    "lng": 151.1013617715406
  },
  {
    "name": "North Avoca",
    "value": 1,
    "lat": -33.4566667,
    "lng": 151.4344444
  },
  {
    "name": "North Bondi",
    "value": 5,
    "lat": -33.882351,
    "lng": 151.2768611
  },
  {
    "name": "North Epping",
    "value": 3,
    "lat": -33.7586111,
    "lng": 151.0941667
  },
  {
    "name": "North Kellyville",
    "value": 6,
    "lat": -33.6859488,
    "lng": 150.9535842
  },
  {
    "name": "North Lambton",
    "value": 2,
    "lat": -32.9038889,
    "lng": 151.7038889
  },
  {
    "name": "North Lismore",
    "value": 31,
    "lat": -28.788,
    "lng": 153.2772
  },
  {
    "name": "North Manly",
    "value": 2,
    "lat": -33.7729035,
    "lng": 151.2707221
  },
  {
    "name": "North Nowra",
    "value": 1,
    "lat": -34.8580611,
    "lng": 150.5827879
  },
  {
    "name": "North Parramatta",
    "value": 8,
    "lat": -33.7889416,
    "lng": 151.00993189462423
  },
  {
    "name": "North Richmond",
    "value": 6,
    "lat": -33.5750113,
    "lng": 150.7056842
  },
  {
    "name": "North Rocks",
    "value": 1,
    "lat": -33.7713052,
    "lng": 151.020996
  },
  {
    "name": "North Rothbury",
    "value": 4,
    "lat": -32.6934,
    "lng": 151.3438
  },
  {
    "name": "North Ryde",
    "value": 3,
    "lat": -33.7975472,
    "lng": 151.127306
  },
  {
    "name": "North St Marys",
    "value": 1,
    "lat": -33.7544444,
    "lng": 150.7858333
  },
  {
    "name": "North Strathfield",
    "value": 3,
    "lat": -33.8590236,
    "lng": 151.0881331
  },
  {
    "name": "North Sydney",
    "value": 10,
    "lat": -33.83431575,
    "lng": 151.20919743582414
  },
  {
    "name": "North Turramurra",
    "value": 1,
    "lat": -33.7328828,
    "lng": 151.128541
  },
  {
    "name": "North Willoughby",
    "value": 1,
    "lat": -33.7975815,
    "lng": 151.18219059933097
  },
  {
    "name": "North Wollongong",
    "value": 8,
    "lat": -34.4121206,
    "lng": 150.8914366
  },
  {
    "name": "North Woodburn",
    "value": 1,
    "lat": -29.0652,
    "lng": 153.3346
  },
  {
    "name": "Northbridge",
    "value": 2,
    "lat": -33.8111111,
    "lng": 151.2175
  },
  {
    "name": "Northmead",
    "value": 5,
    "lat": -33.7844423,
    "lng": 150.9983289
  },
  {
    "name": "Norwest",
    "value": 2,
    "lat": -33.733048,
    "lng": 150.964298
  },
  {
    "name": "Nowra",
    "value": 3,
    "lat": -34.8741198,
    "lng": 150.6004709
  },
  {
    "name": "Nowra Hill",
    "value": 7,
    "lat": -34.9313889,
    "lng": 150.5516667
  },
  {
    "name": "Nulkaba",
    "value": 1,
    "lat": -32.798329,
    "lng": 151.3511084
  },
  {
    "name": "Nunderi",
    "value": 1,
    "lat": -28.3226712,
    "lng": 153.4633068
  },
  {
    "name": "Nurenmerenmong",
    "value": 3,
    "lat": -35.8152,
    "lng": 148.2762
  },
  {
    "name": "Oak Flats",
    "value": 1,
    "lat": -34.5636037,
    "lng": 150.8194112
  },
  {
    "name": "Oakhurst",
    "value": 1,
    "lat": -33.7372222,
    "lng": 150.8347222
  },
  {
    "name": "Oaks Estate",
    "value": 1,
    "lat": -33.40622538080959,
    "lng": 149.61198203177764
  },
  {
    "name": "Oakville",
    "value": 10,
    "lat": -33.6256687,
    "lng": 150.8722092
  },
  {
    "name": "Oatley",
    "value": 2,
    "lat": -33.9815241,
    "lng": 151.0744354
  },
  {
    "name": "Ocean Shores",
    "value": 1,
    "lat": -28.5205629,
    "lng": 153.5399972
  },
  {
    "name": "Oran Park",
    "value": 14,
    "lat": -33.9948805,
    "lng": 150.7402568
  },
  {
    "name": "Orchard Hills",
    "value": 18,
    "lat": -33.7816667,
    "lng": 150.7177778
  },
  {
    "name": "Otford",
    "value": 1,
    "lat": -34.2106925,
    "lng": 151.005819
  },
  {
    "name": "Ourimbah",
    "value": 1,
    "lat": -33.3595346,
    "lng": 151.3699367
  },
  {
    "name": "Oyster Bay",
    "value": 1,
    "lat": -34.0032775,
    "lng": 151.0812354
  },
  {
    "name": "Paddington",
    "value": 7,
    "lat": -33.8841572,
    "lng": 151.2272766
  },
  {
    "name": "Padstow",
    "value": 15,
    "lat": -33.9519026,
    "lng": 151.0323311
  },
  {
    "name": "Padstow Heights",
    "value": 1,
    "lat": -33.9704029,
    "lng": 151.0330262
  },
  {
    "name": "Pagewood",
    "value": 1,
    "lat": -33.9390664,
    "lng": 151.2199363
  },
  {
    "name": "Palm Beach",
    "value": 2,
    "lat": -33.6005473,
    "lng": 151.3231536
  },
  {
    "name": "Panania",
    "value": 7,
    "lat": -33.9543358,
    "lng": 150.9978399
  },
  {
    "name": "Parkes",
    "value": 1,
    "lat": -32.9984036,
    "lng": 148.263513
  },
  {
    "name": "Parramatta",
    "value": 25,
    "lat": -33.8139843,
    "lng": 151.002666
  },
  {
    "name": "Peakhurst",
    "value": 2,
    "lat": -33.9616444,
    "lng": 151.0590667
  },
  {
    "name": "Pelaw Main",
    "value": 1,
    "lat": -32.8318,
    "lng": 151.4818
  },
  {
    "name": "Pembrooke",
    "value": 1,
    "lat": -31.3818,
    "lng": 152.7512
  },
  {
    "name": "Pemulwuy",
    "value": 2,
    "lat": -33.8164641,
    "lng": 150.9284441
  },
  {
    "name": "Pendle Hill",
    "value": 2,
    "lat": -33.8015021,
    "lng": 150.9564483
  },
  {
    "name": "Pennant Hills",
    "value": 13,
    "lat": -33.7384663,
    "lng": 151.0716639
  },
  {
    "name": "Penrith",
    "value": 33,
    "lat": -33.7511954,
    "lng": 150.6941711
  },
  {
    "name": "Penshurst",
    "value": 23,
    "lat": -33.9672788,
    "lng": 151.09118901095007
  },
  {
    "name": "Petersham",
    "value": 1,
    "lat": -33.8945061,
    "lng": 151.1554222
  },
  {
    "name": "Picnic Point",
    "value": 8,
    "lat": -33.9643672,
    "lng": 151.00977292446194
  },
  {
    "name": "Picton",
    "value": 3,
    "lat": -34.1693445,
    "lng": 150.6114983
  },
  {
    "name": "Pitt Town",
    "value": 5,
    "lat": -33.5846533,
    "lng": 150.8709805
  },
  {
    "name": "Pokolbin",
    "value": 2,
    "lat": -32.7792106,
    "lng": 151.2978747
  },
  {
    "name": "Port Botany",
    "value": 3,
    "lat": -33.9734678,
    "lng": 151.2178519
  },
  {
    "name": "Port Hacking",
    "value": 1,
    "lat": -34.07353,
    "lng": 151.12613
  },
  {
    "name": "Port Kembla",
    "value": 5,
    "lat": -34.4703383,
    "lng": 150.8953674
  },
  {
    "name": "Port Macquarie",
    "value": 1,
    "lat": -31.4299499,
    "lng": 152.9103525
  },
  {
    "name": "Port Warratah",
    "value": 1,
    "lat": -32.7785965,
    "lng": 152.1146448
  },
  {
    "name": "Potts Hill",
    "value": 1,
    "lat": -33.89119545,
    "lng": 151.0362585928326
  },
  {
    "name": "Potts Point",
    "value": 1,
    "lat": -33.867522,
    "lng": 151.2243115
  },
  {
    "name": "Prairiewood",
    "value": 2,
    "lat": -33.85956555,
    "lng": 150.9014625468122
  },
  {
    "name": "Prestons",
    "value": 10,
    "lat": -33.9409247,
    "lng": 150.8748897
  },
  {
    "name": "Primbee",
    "value": 1,
    "lat": -34.5034006,
    "lng": 150.8789915
  },
  {
    "name": "Prospect",
    "value": 2,
    "lat": -33.8002421,
    "lng": 150.9218377
  },
  {
    "name": "Punchbowl",
    "value": 18,
    "lat": -33.9254126,
    "lng": 151.0557609
  },
  {
    "name": "Putney",
    "value": 5,
    "lat": -33.826067,
    "lng": 151.1064224
  },
  {
    "name": "Pymble",
    "value": 2,
    "lat": -33.7450185,
    "lng": 151.1424708
  },
  {
    "name": "Pyrmont",
    "value": 19,
    "lat": -33.8692145,
    "lng": 151.1923633
  },
  {
    "name": "Pyrmont Bridge",
    "value": 2,
    "lat": -33.87049175,
    "lng": 151.20009101820727
  },
  {
    "name": "Pyrmot",
    "value": 1,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Quakers Hill",
    "value": 2,
    "lat": -33.7344444,
    "lng": 150.8788889
  },
  {
    "name": "Queanbeyan",
    "value": 11,
    "lat": -35.3524518,
    "lng": 149.2337634
  },
  {
    "name": "Queanbeyan East",
    "value": 2,
    "lat": -35.3455488,
    "lng": 149.2465067
  },
  {
    "name": "Queanbeyan West",
    "value": 1,
    "lat": -35.358092,
    "lng": 149.2070838
  },
  {
    "name": "Queens Park",
    "value": 3,
    "lat": -33.8991667,
    "lng": 151.2472222
  },
  {
    "name": "Raby",
    "value": 1,
    "lat": -34.0233333,
    "lng": 150.8177778
  },
  {
    "name": "Randwick",
    "value": 28,
    "lat": -33.9062434,
    "lng": 151.23465683738365
  },
  {
    "name": "Rathmines",
    "value": 1,
    "lat": -33.0395297,
    "lng": 151.5956536
  },
  {
    "name": "Raymond Terrace",
    "value": 6,
    "lat": -32.7610569,
    "lng": 151.7462299
  },
  {
    "name": "Redfern",
    "value": 5,
    "lat": -33.8931044,
    "lng": 151.2040292
  },
  {
    "name": "Redhead",
    "value": 1,
    "lat": -33.0111111,
    "lng": 151.7077778
  },
  {
    "name": "Regents Park",
    "value": 2,
    "lat": -33.8820048,
    "lng": 151.02569
  },
  {
    "name": "Regentville",
    "value": 1,
    "lat": -33.7708351,
    "lng": 150.6616622
  },
  {
    "name": "Revesby",
    "value": 4,
    "lat": -33.9525282,
    "lng": 151.0149093
  },
  {
    "name": "Revesby Heights",
    "value": 1,
    "lat": -33.9683842,
    "lng": 151.0189891
  },
  {
    "name": "Rhodes",
    "value": 3,
    "lat": -33.8290589,
    "lng": 151.0873578
  },
  {
    "name": "Richmond",
    "value": 12,
    "lat": -28.8632035,
    "lng": 153.0823096
  },
  {
    "name": "Richmond Hill",
    "value": 1,
    "lat": -28.7908,
    "lng": 153.3442
  },
  {
    "name": "Riverstone",
    "value": 15,
    "lat": -33.6797545,
    "lng": 150.8616695
  },
  {
    "name": "Riverview",
    "value": 1,
    "lat": -33.7316997,
    "lng": 150.6307053
  },
  {
    "name": "Riverwood",
    "value": 2,
    "lat": -33.9472222,
    "lng": 151.0530556
  },
  {
    "name": "Robertson",
    "value": 1,
    "lat": -34.59,
    "lng": 150.5927778
  },
  {
    "name": "Rockdale",
    "value": 5,
    "lat": -33.9542619,
    "lng": 151.1403655
  },
  {
    "name": "Rookwood",
    "value": 1,
    "lat": -33.87562665,
    "lng": 151.05609219434473
  },
  {
    "name": "Rooty Hill",
    "value": 2,
    "lat": -33.7688649,
    "lng": 150.8411802
  },
  {
    "name": "Ropes Crossing",
    "value": 1,
    "lat": -33.7291948,
    "lng": 150.7788889
  },
  {
    "name": "Rose Bay",
    "value": 7,
    "lat": -33.8741644,
    "lng": 151.265471
  },
  {
    "name": "Rosebank",
    "value": 1,
    "lat": -28.665,
    "lng": 153.4011111
  },
  {
    "name": "Roseberry",
    "value": 1,
    "lat": -28.4816666,
    "lng": 152.9177777
  },
  {
    "name": "Rosehill",
    "value": 13,
    "lat": -33.8239437,
    "lng": 151.02621193724326
  },
  {
    "name": "Rosemeadow",
    "value": 3,
    "lat": -34.1066667,
    "lng": 150.7927778
  },
  {
    "name": "Roseville",
    "value": 2,
    "lat": -33.773059700000005,
    "lng": 151.20369360783747
  },
  {
    "name": "Roseville Chase",
    "value": 1,
    "lat": -33.773059700000005,
    "lng": 151.20369360783747
  },
  {
    "name": "Rouse Hill",
    "value": 24,
    "lat": -33.6774941,
    "lng": 150.9160933
  },
  {
    "name": "Royal National Park",
    "value": 4,
    "lat": -34.11219955,
    "lng": 151.02672688004589
  },
  {
    "name": "Royalla",
    "value": 1,
    "lat": -35.515,
    "lng": 149.1511111
  },
  {
    "name": "Rozelle",
    "value": 17,
    "lat": -33.8645002,
    "lng": 151.1743543
  },
  {
    "name": "Rutherford",
    "value": 4,
    "lat": -32.7130291,
    "lng": 151.525869
  },
  {
    "name": "Rydalmere",
    "value": 1,
    "lat": -33.8117088,
    "lng": 151.0411702
  },
  {
    "name": "Ryde",
    "value": 7,
    "lat": -33.8125405,
    "lng": 151.1115717
  },
  {
    "name": "Sandringham",
    "value": 3,
    "lat": -33.9971236,
    "lng": 151.1400138
  },
  {
    "name": "Sans Souci",
    "value": 1,
    "lat": -33.9926292,
    "lng": 151.1337972
  },
  {
    "name": "Scheyville",
    "value": 1,
    "lat": -33.596311,
    "lng": 150.89626031617962
  },
  {
    "name": "Schofields",
    "value": 14,
    "lat": -33.6971603,
    "lng": 150.8711915
  },
  {
    "name": "Seaforth",
    "value": 3,
    "lat": -33.7910792,
    "lng": 151.2430284
  },
  {
    "name": "Seven Hills",
    "value": 7,
    "lat": -33.7760305,
    "lng": 150.9427044
  },
  {
    "name": "Shell Cove",
    "value": 4,
    "lat": -34.5975,
    "lng": 150.8633333
  },
  {
    "name": "Shellharbour",
    "value": 2,
    "lat": -34.58647365,
    "lng": 150.76933361779624
  },
  {
    "name": "Shortland",
    "value": 4,
    "lat": -32.8816613,
    "lng": 151.6871202
  },
  {
    "name": "Silverdale",
    "value": 2,
    "lat": -33.9012246,
    "lng": 150.6131826
  },
  {
    "name": "Silverwater",
    "value": 3,
    "lat": -33.8241544,
    "lng": 151.05130809876846
  },
  {
    "name": "Singleton",
    "value": 3,
    "lat": -32.5664044,
    "lng": 151.1733972
  },
  {
    "name": "Singleton Heights",
    "value": 2,
    "lat": -32.5485,
    "lng": 151.1596
  },
  {
    "name": "Skennars Head",
    "value": 3,
    "lat": -28.8277755,
    "lng": 153.6026015
  },
  {
    "name": "Sleepy Hollow",
    "value": 1,
    "lat": -28.4176926,
    "lng": 153.5201596
  },
  {
    "name": "Smeaton Grange",
    "value": 10,
    "lat": -34.0340877,
    "lng": 150.7553777
  },
  {
    "name": "Smithfield",
    "value": 12,
    "lat": -33.8478215,
    "lng": 150.9408736
  },
  {
    "name": "Soldiers Point",
    "value": 1,
    "lat": -32.7001131,
    "lng": 152.0655093
  },
  {
    "name": "Somersby",
    "value": 3,
    "lat": -33.365,
    "lng": 151.2844444
  },
  {
    "name": "South Ballina",
    "value": 1,
    "lat": -28.86574,
    "lng": 153.5659468
  },
  {
    "name": "South Grafton",
    "value": 3,
    "lat": -29.6816773,
    "lng": 152.9336357
  },
  {
    "name": "South Granville",
    "value": 6,
    "lat": -33.8345097,
    "lng": 151.0060111
  },
  {
    "name": "South Gundurimba",
    "value": 1,
    "lat": -28.8818,
    "lng": 153.2512
  },
  {
    "name": "South Hurstville",
    "value": 3,
    "lat": -33.9612886,
    "lng": 151.09931781316638
  },
  {
    "name": "South Lismore",
    "value": 65,
    "lat": -28.8077608,
    "lng": 153.2791883
  },
  {
    "name": "South Maitland",
    "value": 1,
    "lat": -32.7316683,
    "lng": 151.5511123
  },
  {
    "name": "South Murwillumbah",
    "value": 19,
    "lat": -28.3267617,
    "lng": 153.3971541
  },
  {
    "name": "South Nowra",
    "value": 1,
    "lat": -34.8741198,
    "lng": 150.6004709
  },
  {
    "name": "South Penrith",
    "value": 1,
    "lat": -33.7511954,
    "lng": 150.6941711
  },
  {
    "name": "South Penrith.",
    "value": 1,
    "lat": -33.772521,
    "lng": 150.6982616
  },
  {
    "name": "South Turramurra",
    "value": 1,
    "lat": -33.7510951,
    "lng": 151.1084667
  },
  {
    "name": "South Wentworthville",
    "value": 2,
    "lat": -33.8066667,
    "lng": 150.9677778
  },
  {
    "name": "South Windsor",
    "value": 3,
    "lat": -33.6055342,
    "lng": 150.821953
  },
  {
    "name": "Speers Point",
    "value": 7,
    "lat": -32.9633333,
    "lng": 151.6277778
  },
  {
    "name": "Spring Farm",
    "value": 1,
    "lat": -34.0694444,
    "lng": 150.7272284
  },
  {
    "name": "Springwood",
    "value": 2,
    "lat": -33.7017613,
    "lng": 150.5655467
  },
  {
    "name": "St Andrews",
    "value": 3,
    "lat": -33.87396435,
    "lng": 151.20625434992098
  },
  {
    "name": "St Clair",
    "value": 3,
    "lat": -33.7983333,
    "lng": 150.7844444
  },
  {
    "name": "St Georges Basin",
    "value": 1,
    "lat": -35.118678,
    "lng": 150.60525209894485
  },
  {
    "name": "St Helens Park",
    "value": 3,
    "lat": -34.1066667,
    "lng": 150.8094444
  },
  {
    "name": "St Helens Park NSW",
    "value": 2,
    "lat": -34.1066667,
    "lng": 150.8094444
  },
  {
    "name": "St Ives",
    "value": 3,
    "lat": -33.7292063,
    "lng": 151.159396
  },
  {
    "name": "St Ives Chase",
    "value": 1,
    "lat": -33.7030556,
    "lng": 151.1652778
  },
  {
    "name": "St Leonards",
    "value": 6,
    "lat": -33.8225666,
    "lng": 151.1923402
  },
  {
    "name": "St Marys",
    "value": 8,
    "lat": -33.7650204,
    "lng": 150.7677778
  },
  {
    "name": "St Peters",
    "value": 2,
    "lat": -33.9111235,
    "lng": 151.1761345
  },
  {
    "name": "St johns Park",
    "value": 4,
    "lat": -33.8816667,
    "lng": 150.9011111
  },
  {
    "name": "St. Ives",
    "value": 9,
    "lat": -33.7292063,
    "lng": 151.159396
  },
  {
    "name": "Stanmore",
    "value": 3,
    "lat": -33.8979162,
    "lng": 151.1631910433877
  },
  {
    "name": "Stanwell Park",
    "value": 1,
    "lat": -34.2263801,
    "lng": 150.9811154
  },
  {
    "name": "Stockton",
    "value": 1,
    "lat": -32.9127562,
    "lng": 151.7844614
  },
  {
    "name": "Strathfield",
    "value": 14,
    "lat": -33.8791285,
    "lng": 151.0811758
  },
  {
    "name": "Strathfiled South",
    "value": 1,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Stroud",
    "value": 1,
    "lat": -32.4026969,
    "lng": 151.9674197
  },
  {
    "name": "Suffolk Park",
    "value": 3,
    "lat": -28.6867965,
    "lng": 153.6123525
  },
  {
    "name": "Summer Hill",
    "value": 2,
    "lat": -33.8933952,
    "lng": 151.1368729
  },
  {
    "name": "Surry Hills",
    "value": 5,
    "lat": -33.8845123,
    "lng": 151.2100301
  },
  {
    "name": "Sutherland",
    "value": 7,
    "lat": -34.0717253,
    "lng": 151.04929585694757
  },
  {
    "name": "Sutton",
    "value": 2,
    "lat": -35.1616629,
    "lng": 149.2543213
  },
  {
    "name": "Swan Bay",
    "value": 2,
    "lat": -29.0596921,
    "lng": 153.3125051
  },
  {
    "name": "Sydenham",
    "value": 1,
    "lat": -33.9147428,
    "lng": 151.1661069
  },
  {
    "name": "Sydney",
    "value": 73,
    "lat": -33.8698439,
    "lng": 151.2082848
  },
  {
    "name": "Sydney CBD",
    "value": 1,
    "lat": -33.8747234,
    "lng": 151.2053644
  },
  {
    "name": "Sydney Olympic Park",
    "value": 27,
    "lat": -33.842903,
    "lng": 151.072535
  },
  {
    "name": "Sylvania",
    "value": 4,
    "lat": -34.0141205,
    "lng": 151.0988161
  },
  {
    "name": "Sylvania Waters",
    "value": 4,
    "lat": -34.0185844,
    "lng": 151.11228
  },
  {
    "name": "Tahmoor",
    "value": 3,
    "lat": -34.2253646,
    "lng": 150.5907489
  },
  {
    "name": "Tahmoor NSW",
    "value": 1,
    "lat": -34.2253646,
    "lng": 150.5907489
  },
  {
    "name": "Tallawong",
    "value": 4,
    "lat": -33.6917454,
    "lng": 150.9055584
  },
  {
    "name": "Tamarama",
    "value": 1,
    "lat": -33.8987452,
    "lng": 151.2710753
  },
  {
    "name": "Tanilba Bay",
    "value": 1,
    "lat": -32.7307534,
    "lng": 151.9954279
  },
  {
    "name": "Tarro",
    "value": 2,
    "lat": -32.8091372,
    "lng": 151.6697634
  },
  {
    "name": "Tatham",
    "value": 1,
    "lat": -28.9318,
    "lng": 153.1679
  },
  {
    "name": "Taylors Beach",
    "value": 1,
    "lat": -32.7384997,
    "lng": 152.0580889
  },
  {
    "name": "Tea Gardens",
    "value": 1,
    "lat": -32.66923785,
    "lng": 152.16825595
  },
  {
    "name": "Tempe",
    "value": 3,
    "lat": -33.9247552,
    "lng": 151.1647529
  },
  {
    "name": "Tenambit",
    "value": 3,
    "lat": -32.7414268,
    "lng": 151.6097109
  },
  {
    "name": "Tenterfield",
    "value": 1,
    "lat": -28.838430000000002,
    "lng": 152.28131658123107
  },
  {
    "name": "Teralba",
    "value": 3,
    "lat": -32.9625044,
    "lng": 151.603542
  },
  {
    "name": "Terranora",
    "value": 3,
    "lat": -28.2455556,
    "lng": 153.5094444
  },
  {
    "name": "Terrey Hills",
    "value": 1,
    "lat": -33.6918185,
    "lng": 151.2205908
  },
  {
    "name": "The Entrance",
    "value": 2,
    "lat": -33.3440586,
    "lng": 151.4960171
  },
  {
    "name": "The Gables",
    "value": 3,
    "lat": -33.6303326,
    "lng": 150.9031329
  },
  {
    "name": "The Gables NSW",
    "value": 1,
    "lat": -33.6303326,
    "lng": 150.9031329
  },
  {
    "name": "The Oaks",
    "value": 2,
    "lat": -34.0827179,
    "lng": 150.56009580884424
  },
  {
    "name": "The Ponds",
    "value": 3,
    "lat": -33.7066667,
    "lng": 150.9091667
  },
  {
    "name": "The Rocks",
    "value": 15,
    "lat": -33.859992,
    "lng": 151.2083216
  },
  {
    "name": "Theresa Creek",
    "value": 1,
    "lat": -28.769757,
    "lng": 152.791836
  },
  {
    "name": "Thirlmere",
    "value": 1,
    "lat": -34.2342491,
    "lng": 150.5303391
  },
  {
    "name": "Thirroul",
    "value": 3,
    "lat": -34.3181745,
    "lng": 150.9189104
  },
  {
    "name": "Thornleigh",
    "value": 7,
    "lat": -33.7236616,
    "lng": 151.0809407
  },
  {
    "name": "Thornton",
    "value": 4,
    "lat": -32.7816614,
    "lng": 151.6427696
  },
  {
    "name": "Tighes HIll",
    "value": 4,
    "lat": -32.9045031,
    "lng": 151.7562052
  },
  {
    "name": "Tomago",
    "value": 7,
    "lat": -32.815,
    "lng": 151.7011111
  },
  {
    "name": "Tomewin",
    "value": 1,
    "lat": -28.2566667,
    "lng": 153.3761111
  },
  {
    "name": "Toongabbie",
    "value": 3,
    "lat": -33.7866894,
    "lng": 150.9526498
  },
  {
    "name": "Toronto",
    "value": 3,
    "lat": -33.008555900000005,
    "lng": 151.58213249154994
  },
  {
    "name": "Toukley",
    "value": 2,
    "lat": -33.2633333,
    "lng": 151.5313889
  },
  {
    "name": "Tralee",
    "value": 22,
    "lat": -35.4305,
    "lng": 149.1671
  },
  {
    "name": "Tregear",
    "value": 1,
    "lat": -33.7486957,
    "lng": 150.7957569
  },
  {
    "name": "Tuckombil",
    "value": 1,
    "lat": -28.8152,
    "lng": 153.4679
  },
  {
    "name": "Tuggerawong",
    "value": 4,
    "lat": -33.2816667,
    "lng": 151.4844444
  },
  {
    "name": "Tullimbar",
    "value": 9,
    "lat": -34.574733,
    "lng": 150.752619
  },
  {
    "name": "Tullymorgan",
    "value": 1,
    "lat": -29.3735,
    "lng": 153.1179
  },
  {
    "name": "Tumbulgum",
    "value": 3,
    "lat": -28.2751369,
    "lng": 153.4611025
  },
  {
    "name": "Tuntable Creek",
    "value": 1,
    "lat": -28.6318,
    "lng": 153.2679
  },
  {
    "name": "Turramurra",
    "value": 3,
    "lat": -33.7328828,
    "lng": 151.128541
  },
  {
    "name": "Turrella",
    "value": 3,
    "lat": -33.9299188,
    "lng": 151.1399608
  },
  {
    "name": "Turvey Park",
    "value": 3,
    "lat": -35.1280551,
    "lng": 147.3574738
  },
  {
    "name": "Tweed Heads",
    "value": 6,
    "lat": -28.1786639,
    "lng": 153.5369986
  },
  {
    "name": "Tweed Heads South",
    "value": 1,
    "lat": -28.1786639,
    "lng": 153.5369986
  },
  {
    "name": "Tweed Heads West",
    "value": 5,
    "lat": -28.1885679,
    "lng": 153.5032351
  },
  {
    "name": "Ultimo",
    "value": 9,
    "lat": -33.8794728,
    "lng": 151.1984346
  },
  {
    "name": "Umina Beach",
    "value": 2,
    "lat": -33.5177778,
    "lng": 151.3094444
  },
  {
    "name": "Unanderra",
    "value": 1,
    "lat": -34.4546772,
    "lng": 150.8460733
  },
  {
    "name": "Upper Colo",
    "value": 1,
    "lat": -33.4213834,
    "lng": 150.7255258
  },
  {
    "name": "Upper Main Arm",
    "value": 1,
    "lat": -28.4930816,
    "lng": 153.3986784
  },
  {
    "name": "Valentine",
    "value": 2,
    "lat": -33.015,
    "lng": 151.6344444
  },
  {
    "name": "Varroville",
    "value": 1,
    "lat": -34.0066667,
    "lng": 150.8177778
  },
  {
    "name": "Vaucluse",
    "value": 10,
    "lat": -33.8558564,
    "lng": 151.2761018
  },
  {
    "name": "Victoria Park",
    "value": 2,
    "lat": -33.886642,
    "lng": 151.19235903028192
  },
  {
    "name": "Villawood",
    "value": 13,
    "lat": -33.8808812,
    "lng": 150.9761642
  },
  {
    "name": "Vineyard",
    "value": 5,
    "lat": -33.6483333,
    "lng": 150.8677778
  },
  {
    "name": "Wadalba",
    "value": 1,
    "lat": -33.2733333,
    "lng": 151.4677778
  },
  {
    "name": "Wahroonga",
    "value": 18,
    "lat": -33.7183413,
    "lng": 151.1174435
  },
  {
    "name": "Waitara",
    "value": 3,
    "lat": -33.7109319,
    "lng": 151.1047986
  },
  {
    "name": "Wallsend",
    "value": 9,
    "lat": -32.9057901,
    "lng": 151.6656025
  },
  {
    "name": "Wamboin",
    "value": 3,
    "lat": -35.2460342,
    "lng": 149.3239423
  },
  {
    "name": "Wangi Wangi",
    "value": 1,
    "lat": -33.0704798,
    "lng": 151.5959469
  },
  {
    "name": "Waratah",
    "value": 8,
    "lat": -32.9023676,
    "lng": 151.7312067
  },
  {
    "name": "Warners Bay",
    "value": 4,
    "lat": -32.96809075,
    "lng": 151.65367518452393
  },
  {
    "name": "Warnervale",
    "value": 2,
    "lat": -33.2405145,
    "lng": 151.4301373
  },
  {
    "name": "Warragamba",
    "value": 1,
    "lat": -33.8830611,
    "lng": 150.5961932
  },
  {
    "name": "Warrawee",
    "value": 1,
    "lat": -33.7242007,
    "lng": 151.1217112
  },
  {
    "name": "Warrawong",
    "value": 6,
    "lat": -34.4866791,
    "lng": 150.8825597
  },
  {
    "name": "Warriewood",
    "value": 3,
    "lat": -33.690306,
    "lng": 151.2942716
  },
  {
    "name": "Warwick Farm",
    "value": 3,
    "lat": -33.9133304,
    "lng": 150.9351023
  },
  {
    "name": "Waterfall",
    "value": 4,
    "lat": -34.1344488,
    "lng": 150.9944558
  },
  {
    "name": "Waterfall NSW",
    "value": 1,
    "lat": -34.1347694,
    "lng": 150.9931332
  },
  {
    "name": "Waterloo",
    "value": 1,
    "lat": -33.9002762,
    "lng": 151.2073137
  },
  {
    "name": "Watsons Bay",
    "value": 1,
    "lat": -33.8432736,
    "lng": 151.2825736
  },
  {
    "name": "Wattamolla",
    "value": 1,
    "lat": -34.1377093,
    "lng": 151.1147646
  },
  {
    "name": "Wattle Grove",
    "value": 1,
    "lat": -33.9564013,
    "lng": 150.9405862
  },
  {
    "name": "Waverton",
    "value": 5,
    "lat": -33.8380922,
    "lng": 151.1976471
  },
  {
    "name": "Wellington",
    "value": 1,
    "lat": -32.5542815,
    "lng": 148.9515327
  },
  {
    "name": "Wentworth Park",
    "value": 1,
    "lat": -33.8756585,
    "lng": 151.19191628631916
  },
  {
    "name": "Wentworth Point",
    "value": 5,
    "lat": -33.8268958,
    "lng": 151.0774351
  },
  {
    "name": "Wentworthville",
    "value": 1,
    "lat": -33.8066667,
    "lng": 150.9677778
  },
  {
    "name": "Werrington",
    "value": 4,
    "lat": -33.758666,
    "lng": 150.7579617
  },
  {
    "name": "Werrington County",
    "value": 1,
    "lat": -33.7469444,
    "lng": 150.7486111
  },
  {
    "name": "Werrington Downs",
    "value": 1,
    "lat": -33.7413889,
    "lng": 150.7322222
  },
  {
    "name": "West Dapto",
    "value": 4,
    "lat": -34.472151749999995,
    "lng": 150.7945299039489
  },
  {
    "name": "West Gosford",
    "value": 1,
    "lat": -33.415,
    "lng": 151.3177778
  },
  {
    "name": "West Pennant Hills",
    "value": 4,
    "lat": -33.7478359,
    "lng": 151.0350621
  },
  {
    "name": "West Pymble",
    "value": 5,
    "lat": -33.7646844,
    "lng": 151.1318993
  },
  {
    "name": "West Ryde",
    "value": 6,
    "lat": -33.8070374,
    "lng": 151.0902904
  },
  {
    "name": "West Wallsend",
    "value": 1,
    "lat": -32.9032721,
    "lng": 151.5818517
  },
  {
    "name": "West Wollongong",
    "value": 1,
    "lat": -34.4242537,
    "lng": 150.8673533
  },
  {
    "name": "Westleigh",
    "value": 1,
    "lat": -33.715,
    "lng": 151.0677778
  },
  {
    "name": "Westmead",
    "value": 23,
    "lat": -33.8076498,
    "lng": 150.9877265
  },
  {
    "name": "Weston",
    "value": 4,
    "lat": -32.8149936,
    "lng": 151.4511097
  },
  {
    "name": "Wetherill Park",
    "value": 20,
    "lat": -33.8483333,
    "lng": 150.9011111
  },
  {
    "name": "Whalan",
    "value": 1,
    "lat": -33.7566667,
    "lng": 150.8094444
  },
  {
    "name": "Whitebridge",
    "value": 1,
    "lat": -32.9736111,
    "lng": 151.7158333
  },
  {
    "name": "Wickham",
    "value": 1,
    "lat": -32.9233333,
    "lng": 151.7594444
  },
  {
    "name": "Wilberforce",
    "value": 2,
    "lat": -33.549451,
    "lng": 150.8474116
  },
  {
    "name": "Wiley Park",
    "value": 2,
    "lat": -33.9229545,
    "lng": 151.067336
  },
  {
    "name": "Williamstown",
    "value": 4,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Williamtown",
    "value": 9,
    "lat": -32.7944905,
    "lng": 151.84004247877124
  },
  {
    "name": "Willmot",
    "value": 2,
    "lat": -33.7247222,
    "lng": 150.7938889
  },
  {
    "name": "Wilsons Valley",
    "value": 1,
    "lat": -36.3485,
    "lng": 148.5179
  },
  {
    "name": "Wilston",
    "value": 11,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Windale",
    "value": 1,
    "lat": -32.9916667,
    "lng": 151.6813889
  },
  {
    "name": "Windsor",
    "value": 2,
    "lat": -33.6055342,
    "lng": 150.821953
  },
  {
    "name": "Wingham",
    "value": 1,
    "lat": -31.865,
    "lng": 152.3677778
  },
  {
    "name": "Winston Hills",
    "value": 2,
    "lat": -33.7761098,
    "lng": 150.9816606
  },
  {
    "name": "Wolli Creek",
    "value": 1,
    "lat": -33.9285225,
    "lng": 151.1539888
  },
  {
    "name": "Wollongbar",
    "value": 16,
    "lat": -28.820601,
    "lng": 153.4219372
  },
  {
    "name": "Wollongong",
    "value": 25,
    "lat": -34.4278083,
    "lng": 150.893054
  },
  {
    "name": "Wongawilli",
    "value": 1,
    "lat": -34.4766667,
    "lng": 150.755
  },
  {
    "name": "Woodbine",
    "value": 1,
    "lat": -34.0468369,
    "lng": 150.8242711
  },
  {
    "name": "Woodburn",
    "value": 8,
    "lat": -29.0722558,
    "lng": 153.3437662
  },
  {
    "name": "Woodenbong",
    "value": 1,
    "lat": -28.3913455,
    "lng": 152.6120214
  },
  {
    "name": "Woollahra",
    "value": 3,
    "lat": -33.86183355,
    "lng": 151.27333181758672
  },
  {
    "name": "Woollahra Council",
    "value": 3,
    "lat": -33.86183355,
    "lng": 151.27333181758672
  },
  {
    "name": "Woolloomooloo",
    "value": 3,
    "lat": -33.8718758,
    "lng": 151.2192218
  },
  {
    "name": "Woolooware",
    "value": 6,
    "lat": -34.0448411,
    "lng": 151.1401717
  },
  {
    "name": "Woolwich",
    "value": 4,
    "lat": -33.8401988,
    "lng": 151.1710614
  },
  {
    "name": "Woongarrah",
    "value": 3,
    "lat": -33.2316667,
    "lng": 151.4677778
  },
  {
    "name": "Woonona",
    "value": 3,
    "lat": -34.3495876,
    "lng": 150.9152056
  },
  {
    "name": "Woronora",
    "value": 2,
    "lat": -34.0589366,
    "lng": 150.9959138
  },
  {
    "name": "Woronora Heights",
    "value": 3,
    "lat": -34.034387,
    "lng": 151.027167
  },
  {
    "name": "Woy Woy",
    "value": 1,
    "lat": -33.4880548,
    "lng": 151.3274925
  },
  {
    "name": "Wuuluman",
    "value": 2,
    "lat": -32.5485,
    "lng": 149.0679
  },
  {
    "name": "Wyee",
    "value": 7,
    "lat": -33.1803459,
    "lng": 151.4871062
  },
  {
    "name": "Wyoming",
    "value": 3,
    "lat": -33.4066667,
    "lng": 151.3594444
  },
  {
    "name": "Wyong",
    "value": 7,
    "lat": -33.2825132,
    "lng": 151.4256691
  },
  {
    "name": "Yagoona",
    "value": 2,
    "lat": -33.9067491,
    "lng": 151.0243075
  },
  {
    "name": "Yallah",
    "value": 1,
    "lat": -34.5418228,
    "lng": 150.784154
  },
  {
    "name": "Yamba",
    "value": 8,
    "lat": -29.44,
    "lng": 153.3594444
  },
  {
    "name": "Yarrangobilly",
    "value": 1,
    "lat": -35.6483333,
    "lng": 148.4677778
  },
  {
    "name": "Yass",
    "value": 8,
    "lat": -34.8418629,
    "lng": 148.9110055
  },
  {
    "name": "Yennora",
    "value": 1,
    "lat": -33.8646287,
    "lng": 150.9711499
  },
  {
    "name": "Young",
    "value": 3,
    "lat": -33.86860675,
    "lng": 151.2174175784304
  },
  {
    "name": "Yowie Bay",
    "value": 1,
    "lat": -34.0502778,
    "lng": 151.1033333
  },
  {
    "name": "Zetland",
    "value": 15,
    "lat": -33.9076623,
    "lng": 151.2082183
  },
  {
    "name": "condong",
    "value": 3,
    "lat": -28.3114787,
    "lng": 153.4351183
  }
];
